import React, { useState, useEffect, useMemo, useRef } from 'react';
import videoDb from './video-db.json';
import { 
  Play, 
  Pause, 
  ChevronLeft, 
  ChevronRight, 
  Search, 
  Sparkles, 
  Share2, 
  Maximize2, 
  Minimize2, 
  Tv, 
  Info, 
  Award, 
  Sliders, 
  ExternalLink, 
  Send, 
  RefreshCw, 
  Check,
  Heart,
  HelpCircle,
  Volume2,
  VolumeX,
  FileText
} from 'lucide-react';

// Raw winner text dataset from lovetheworkmore.com/2026-2/
const RAW_WINNERS_TEXT = `
GRAND PRIX / TITANIUM
[TITANIUM GRAND PRIX] HAVEN – SUNCORP INSURANCE (LEO SYDNEY)
[TITANIUM + BRAND ACTIVATION] EXPEDITION IMPOSSIBLE – COLUMBIA SPORTSWEAR (ADAM&EVE\\TBWA/LONDON)
[TITANIUM + LIONS HEALTH GRAND PRIX FOR GOOD] VEHICLE OF HOPE – CARITAS (DIFFER STOCKHOLM)
[TITANIUM] 600K NETWORK – RAINBOW LOBSTER MEXICO (COMANDO CON VENEZUELA)
[TITANIUM] OREO COWS – OREO (VML NEW YORK)
[TITANIUM] THE LEGACY OF VIRGINIA GIUFFRE – VIRGINIA GIUFFRE (DINI VON MUEFFLING COMMUNICATIONS NEW YORK)
[CREATIVE B2B] THE FAROE ISLANDS SPACE PROGRAM – SKF (NORD DDB STOCKHOLM)
[CREATIVE BRAND] ABINBEV: CREATIVITY AT SCALE
[CREATIVE BUSINESS TRANSFORMATION] THE WEDDING RICE – WIKIFARMER (MCCANN ATHENS)
[CREATIVE COMMERCE] LUCKY FAN INDEX – WISŁA KRAKÓW FOOTBALL CLUB (VML KRAKOKW)
[CREATIVE DATA] SOS POS – BCP (CIRCUS GREY LIMA)
[CREATIVE EFFECTIVENESS] THREE WORDS – AXA (PUBLICIS CONSEIL PARIS)
[CREATIVE STRATEGY] THE PUB THAT REFUSED TO DIE – HEINEKEN (LEPUB MILAN)
[DESIGN] APPLE TV REBRAND – APPLE TV (TBWA\\MEDIA ARTS LAB LOS ANGELES)
[DIGITAL CRAFT] PROJECT GENIE – GOOGLE (GOOGLE MOUNTAIN VIEW)
[DIRECT] UVA UVA BOMBÓN – UVA APP (DE LA CRUZ OGILVY MADRID)
[ENTERTAINMENT + ENTERTAINMENT LIONS FOR MUSIC] ORIGINAL FOREVER – ADIDAS (JOHANNES LEONARDO NEW YORK)
[ENTERTAINMENT LIONS FOR GAMING] COPYCATS WELCOME – CLASH ROYALE (DAVID NEW YORK)
[ENTERTAINMENT LIONS FOR MUSIC] ROSALÍA FT. BJÖRK, YVES TUMOR – BERGHAIN (CANADA BARCELONA)
[ENTERTAINMENT LIONS FOR SPORT] THE THOUSAND SPONSORS OF MUNI – CLUB DEPORTIVO MUNICIPAL (MCCANN LIMA)
[FILM CRAFT] YOUR WAY OUT – COINBASE (ISLE OF ANY NEW YORK)
[FILM] CAN I GET a SIX PACK QUICKLY? – CLAUDE (MOTHER LONDON)
[FILM] HOW CAN I COMMUNICATE BETTER WITH MY MOM? – CLAUDE (MOTHER LONDON)
[GLASS: THE LION FOR CHANGE] NIGRUM CORPUS – IDOMED (ARTPLAN SÃO PAULO)
[INDUSTRY CRAFT] TINY COFFEE SHOPS – DE'LONGHI (LOLA MADRID)
[INNOVATION] SUPERNOVA ADAPTIVE – ADIDAS (TBWA\\TORONTO)
[LUXURY] WARMER TOGETHER – MONCLER (WESAYHI MILAN)
[MEDIA] BUILD YOUR OWN SUPER BOWL COMMERCIAL – UBER EATS (SPECIAL LOS ANGELES)
[OUTDOOR] FIELD BARCODE – MERCADO LIVRE (GUT SÃO PAULO)
[PHARMA] RELAX YOUR TIGHT END – NOVARTIS (FALLON MINNEAPOLIS)
[PHARMA] THE PERIODIC FABLE – THE ORDINARY (UNCOMMON CREATIVE STUDIO LONDON)
[PR] THE KITKAT HEIST – KITKAT (VML LONDON)
[PRINT & PUBLISHING] LOOK FAMILIAR? – HEINZ (RETHINK TORONTO)
[RADIO & AUDIO] COQUÍ ALARMED – HYUNDAI (BBDO PUERTO RICO)
[SOCIAL CREATOR] COULD HAVE BEEN A HEINEKEN – HEINEKEN (LEPUB MILAN & SÃO PAULO)
[SUSTAINABLE DEVELOPMENT GOALS] PAID SICK LEAVE FOR COWS – TOO GOOD (THE PARTNERSHIP AGENCY NAIROBI)

GOLD
“BASED ON A TRUE STORY” – MISSING PEOPLE (BBH LONDON)
A TIME AND A PLACE – CLAUDE (MOTHER LONDON)
ART'S MISSING PERIOD – KOTEX (DAVID LONDON & OGILVY SINGAPORE)
BAD BUNNY HALFTIME SHOW – SHOT ON IPHONE – APPLE (APPLE CUPERTINO)
BEAT CANCER OFF – FUCK CANCER (VML NEW YORK)
BULLET MACHINE – LA UNION NEWSPAPER AND ARTICLE 19 (GREY MEXICO)
CAMERA ROLLS: GIG, WEDDING, BOWLING – MCDONALD'S (LEO LONDON)
CHICKEN SCREAMS FOR COKE – COCA-COLA (VML NEW YORK & SÃO PAULO)
CLEAN MY NAME – CIF (DROGA5 SÃO PAULO)
DANCEBOOK BRASIL – BRADESCO (LOVELY SÃO PAULO)
DARK MODE ADS – PLENITUDE (LEPUB MILAN)
ONE MORE QUESTION – LALCEC (GREY ARGENTINA BUENOS AIRES)
THE RELATIONSHIP AID – SPECSAVERS (GOLIN KETCHUM LONDON)
DEAR DIFFERENCE – NIKKA WHISKY (DENTSU TOKYO)
DEFINING HELP – KIDS HELP PHONE (MCCANN TORONTO)
DONATE TO PLAY – GRUPO PULSA (PUBLICIS SÃO PAULO)
DOVE R/EAL REVIEWS – DOVE (DAVID LONDON)
EVERYBODY COINBASE – COINBASE (ISLE OF ANY NEW YORK)
EVERYONE WANTS A PIECE – LEGO (OUR LEGO AGENCY BILLUND)
EXPENSIVE SH*T – HUGGIES (MCCANN NEW YORK)
FOR YOUR RIGHT TO BE CURIOUS – NPR (MISCHIEF AT NO FIXED ADDRESS NEW YORK)
HEINZ DIPPER – HEINZ KETCHUP (RETHINK TORONTO)
HELICOPTER – A$AP ROCKY (AWGE SOMESUCH LOS ANGELES)
HOPE, MORNINGS, PICKY, AWAKE – IKEA (TRY OSLO)
I THINK OF YOU DYING – LIFE360 (ALTO LOS ANGELES)
I'M NOT REMARKABLE – APPLE (APPLE CUPERTINO)
ICONIC HOME – DUNKIN' AT HOME (BBH NEW YORK)
KYLE F*CKING CONNOR – KFC (COURAGE TORONTO)
LANGUAGE OF BEDWETTING – AUTISM SOCIETY (MCCANN NEW YORK)
LET'S END FAST TECH – BACK MARKET (MARCEL PARIS)
LIME GUIDES – CORONA (GREY NEW YORK)
NO PROJECT WITHOUT DRAMA – HORNBACH (HEIMAT\\TBWA BERLIN)
PEDIGREE CARAMELO – PEDIGREE (ALMAPBBDO SÃO PAULO)
POCKET-SIZED HALFTIME SHOW – CLASH ROYALE (UNCOMMON CREATIVE STUDIO STOCKHOLM)
POPE YES – POPEYES (GUT MIAMI)
PROTECT THE PEANUT – MARS SNACKING (BBDO NEW YORK)
RESIZE THE PRICE – AGUILA (DAVID BOGOTÁ)
SEARCHING FOR BIRDS ON WIRES – ABRADEE (AFRICA CREATIVE SÃO PAULO)
SHAPE OF DREAMS – ON (ON AG ZURICH)
SLEEP TALK REVIEWS – IKEA (RETHINK TORONTO)
SOIL STAY – TRA MONGKUT FERTILIZER (VML BANGKOK)
SUNBURNT CAR – MYCAR (TBWA\\SYDNEY)
T-REX LEATHER – LAB-GROWN LEATHER (VML PARIS)
THE LAST COKE IN THE DESERT – COCA-COLA (VML NEW YORK)
THE MĀORI ROLL CALL – WHĀNAU ORA (MOTION SICKNESS AUCKLAND)
THE NEW FACE OF LEGS – CERAVE (BOLDED NEW YORK)
THE PERIOD UNIFORM – SOMOS MARTINA (SERVICEPLAN MUNICH)
THE SAFE PACK – TUPHARMA 365 (VML MADRID)
THE SWEDISH PRESCRIPTION – VISIT SWEDEN (PRIME WEBER SHANDWICK STOCKHOLM)
THE TIGER – GUCCI (MJZ LOS ANGELES)
THE TROJAN FAX – IUCN FRENCH COMMITTEE X FUJIFILM PRINT (BETC PARIS)
THE VOLVO CARS SAFETY STANDARD – VOLVO CARS (VOLVO GOTHENBURG)
TIFFANY × NETFLIX'S FRANKENSTEIN – TIFFANY (TIFFANY NEW YORK & NETFLIX BRAND CREATIVE STUDIO)
TOCAYOS – HEINEKEN (LEPUB MILAN)
UBERLÂNDIA E.C. – UBER (WIEDEN+KENNEDY SÃO PAULO)
UTRECHT ENERGIZED – RENAULT (PUBLICIS AMSTERDAM)
VASELINE AND THE REAL NIGERIAN PRINCE – VASELINE (LEO SINGAPORE)
VASELINE ORIGINALS – VASELINE (OGILVY SINGAPORE)
VIAGRA BLUE BRANDS – VIATRI (OGILVY SHANGHAI)
WELCOME BACK, PAISANO – TECATE (LEPUB MEXICO)
WHO'S WAITING FOR YOU? – CERVEZA VICTORIA (WIEDEN+KENNEDY MEXICO)

SILVER
#UNCENSORYOURHEALTH – LADYWELL (SAATCHI & SAATCHI NEW YORK)
2036 – ASSOCIATION ANTOINE ALLÉNO (HAVAS PARIS)
867-5309 – THE CANCER SUPPORT COMMUNITY (KLICK HEALTH TORONTO)
A CRITTER CAROL – APPLE (TBWA\\MEDIA ARTS LAB LOS ANGELES)
A DRUGSTORE IN YOUR PESEBRE – FARMACIAS ECONÓMICAS (BE FLAMINGO SAN JOSÉ)
A MOTHER'S COMMENTARY – REPORTERS WITHOUT BORDERS (THE GOOD COMPANY PARIS)
AFTER SHIT HAPPENED SERVICE – SHIELD INSURANCE (VML BANGKOK)
AMAZONIA – EMBRATUR (FUTUREBRAND SÃO PAULO)
AMAZÔNIA ALIVE – BOOK – VALE SA (ARTPLAN RIO DE JANEIRO)
BACK TO KAI TAK – CATHAY (LEO HONG KONG)
BAD BUNNY HALFTIME SHOW CAMPAIGN – APPLE (APPLE CUPERTINO)
BEAT CANCER OFF FILM – FUCK CANCER (VML NEW YORK)
BLIZZARD AS USUAL – TIM HORTONS (GUT TORONTO)
CHANGE MY MIND – CZECH TELEVISION (PUNK FILM PRAGUE)
CHEETOS THING-ERTIPS – CHEETOS (GS&P)
CHUPA CHUPS IMPOSSIBLE – CHUPA CHUPS (BBH LONDON)
CODE FOR THE PROTECTION AND INCLUSION OF BLACK CONSUMERS – L'ORÉAL LUXE (BETA COLLECTIVE NEW YORK)
CODE HER – BOTICÁRIO (ALMAPBBDO SÃO PAULO)
CONDENSED IDENTITY – TIGRIS (HAKUHODO TOKYO)
CRAFTMAN.SHIPS – SHIPS (BAKUHODO GRAVITY TOKYO)
DEAR DIFFERENCE – NIKKA WHISKY (DENTSU TOKYO)
DELIVERED BY TETRIS – LA POSTE (BETC/PARIS)
DISCOUNT CHANTS – MERCADO LIBRE (GUT BUENOS AIRES)
DOORBELL ADS – MERCADO LIBRE (GUT BUENOS AIRES)
DRESS YOURSELF – SIMONS (SID LEE MONTREAL)
DRESSED FOR WIMBLEDON – STELLA ARTOIS (GUT AMSTERDAM)
DROP IN – ELECTRONIC ARTS SKATE (UNCOMMON CREATIVE STUDIO LONDON)
DUOBELL – SKODA (AMVBBDO LONDON)
FAIR PLAY – MISTERIO PUBLICO DO DISTRITO FEDERAL (OGILVY HEALTH NEW YORK)
FIRECATCHERS – SAPEURS POMPIERS DE FRANCE (HAVAS PLAY PARIS)
FIRST SCHOOL POO – ANDREX (KIMBERLY-CLARK SURREY)
FOR PAPA! – INSTACART (MCCANN NEW YORK)
GAMING FLUTE – SKITTLES (TBWA\\CHIAT\\DAY CHICAGO)
HARD TO MAKE EASY TO DRINK – HAWKSTONE (SMITH & JONES FILMS LONDON)
HIDDEN TAGS – IKEA (UZINA LISBON)
IKEA BRIGHTON STORE LAUNCH – IKEA (MOTHER LONDON)
IKEA PREOWNED/SECOND-HAND MARKETPLACE – IKEA (MCCANN MADRID)
INDIANIS DENTRIS – COLGATE (THE REFINERY MUMBAI)
INFINITE SAREE – RED DOT FOUNDATION (KLICK HEALTH TORONTO)
IT STARTS OUTSIDE – DIRT IS GOOD | PERSIL (FRANK LONDON)
KEEP THINKING – CLAUDE (MOTHER LONDON)
KITKAT SECURITY DETAIL – KITKAT (COURAGE TORONTO)
L'ULTIMO UOMO REALE “THE LAST REAL MAN” – THE REALREAL (TEAM ONE LOS ANGELES)
LET IT FLY – SAUDIA AIRLINES (PUBLICIS KSA RIYADH)
LOOK FOR THE LEAF – MAPLE LEAF FOODS (NO FIXED ADDRESS TORONTO)
MADE TO SHARE – CADBURY (VCCP LONDON)
MAGNIF-EYE – 1001 OPTOMETRY (VML SYDNEY)
MANDATORY VACATION PACKAGES – CÁMARA COLOMBIANA DE COMERCIO ELECTRÓNICO (NAME BOGOTÁ)
MNTANA KA GOGO – VASELINE (VML JOHANNESBURG)
NO BLUE, NO GREEN – SOS OCEANO (DROGA5 SÃO PAULO)
NOTHING STOPS WOMEN'S RUGBY – AXA FRANCE (PUBLICIS CONSEIL PARIS)
OLYMPIC RINGS PASTA – INTERNATIONAL OLYMPIC (INTERNATIONAL OLYMPIC COMMITTEE LAUSANNE)
OWN YOUR FLOW – KOTEX (MCCANN NEW YORK)
PLAYED BY HUMANS – JAZZ IS DEAD (TBWA\\CHIAT\\DAY LOS ANGELES)
PRIME TIME 0.7 – FRECUENCIA LATINA (FAHRENHEIT DDB LIMA)
RADIO TIME MACHINE – NICHII GAKKAN (TBWA\\HAKUHODO TOKYO)
RECIPE FOR CHANGE – PUCK (FP7 MCCANN DUBAI)
REFLECTIONS – BRITISH AIRWAYS (UNCOMMON CREATIVE STUDIO LONDON)
REVERSE MEDIA SCHEDULE – SEA CLEANERS & JCDECAUX (DENTSU CREATIVE AUCKLAND)
SANTA MARIA PUEBLO HOTEL – SENATUR (ONIRIA\\TBWA ASUNCIÓN)
SCORECOUPONS – MERCADO LIBRE (GUT SÃO PAULO)
SERVING SINGLES – KNORR (FRANK LONDON)
SHOT WITHOUT PERMISSION – AMSTEL (INGO STOCKHOLM)
SHOWROOM ON ICE – LOODS 5 (OGILVY AMSTERDAM)
SILENT EDITION – JEEP (PUBLICIS TORONTO)
SPOTS FOR SHOPS – PARKIN (FP7 MCCANN DUBAI)
TABLEAU – JOHN LEWIS & PARTNERS (SAATCHI & SAATCHI LONDON)
TERMS AND CONDITIONS OF BEING A GIRL – VILLE DE PARIS (BETC PARIS)
THE BIRDWATCHER – SPOOR (FP7 MCCANN DUBAI)
THE BITE – BURGER KING (BARKLEYOKRP CHICAGO & MOJO SUPERMARKET NEW YORK)
THE CHOICE – PEPSI (PEPSICO PURCHASE)
THE CLUB IS YOURS – EA SPORTS FC (UNCOMMON CREATIVE STUDIO LONDON)
THE DR PEPPER JINGLE – DR PEPPER (DEUTSCH LOS ANGELES)
THE FEATHERED LAMB – VISA FRANCE (MARCEL PARIS)
THE FILET-O-FISH FACEBOOK SOCIETY OF 2012 – MCDONALD'S (LEO CHICAGO)
THE GOLDEN ZONE – MCDONALD'S (TBWA\\COLOMBIA BOGOTÁ)
THE GREY SWAN – NYCOPLUS (11:11 OSLO)
THE GUCCI LIDO CAMPAIGN – GUCCI (SMUGGLER LOS ANGELES)
THE HEALING STAGE – ARMED FORCE OF UKRAINE (SAATCHI & SAATCHI KYIV)
THE KIDNEY PASS – WAY OUT WEST (NORD GOTHENBURG)
THE LIFE-SAVING RECEIPT – CHOROGUSAN FOR CHILDREN (DMINUSONE SEOUL)
THE MOST EPIC WATCH PARTY GROUP – LAY'S (SLAP GLOBAL BUENOS AIRES)
THE PAID RELIEF, NA CONTA DA DOR – OPELLA (PUBLICIS SÃO PAULO)
THE PASSWORD HEIST – LEROY MERLIN (BETC PARIS)
THE PHILIPSTOWN WIRECAR GRAND PRIX – THE PHILIPSTOWN WIRECAR FOUNDATION (ACCENTURE SONG SOUTH AFRICA & HAMBURG)
THE RING: THE LEGACY CONTINUES – THE RING (BIGTIME CREATIVE SHOP LOS ANGELES)
THE SWITCH HIT BY MIKKELLER – MIKKELLER & UGLY HALF BEER (OGILVY COPENHAGEN)
THE UNBURIED CASKET – WOMEN FOR CHANGE (EDELMAN JOHANNESBURG)
THE UNDROPPED KIT – ASICS (GUT TORONTO)
THE UNOFFICIAL OFFICIAL SOUND OF F1 – STING (LEO MUMBAI)
THE YANGZHOU QIAO BEI MUSICAL SUITE – YANGZHOU MUNICIPAL (TBWA\\SHANGHAI)
TIKTOK CURRENCY – VEIKKO KAUPPA.COM (BOB THE ROBOT HELSINKI)
TILT ACCESSIBLE BEAUTY – TILT (ESTABLISHED NEW YORK)
U UP? – IKEA (RETHINK TORONTO)
UNAVAILABLE – SQUARESPACE (SQUARESPACE NEW YORK)
UNCOVERING RACISM – SPORT CLUB CORINTHIANS PAULISTA (ALMAPBBDO SÃO PAULO)
UNFADING LOVE – THAI LIFE INSURANCE CO. (OGILVY BANGKOK)
UNWATCHED GOALS – BRAHMA (AFRICA CREATIVE SÃO PAULO)
VASELINE VERIFIED – UNILEVER (OGILVY SINGAPORE)
YOU'VE BEEN WARNED – NETFLIX (WIEDEN+KENNEDY PORTLAND)
ZIP CODE EXAM – EQUALITY HEALTH FOUNDATION (AREA 23 NEW YORK)

BRONZE
¡HOLA! – COLAS ICELAND (PIPAR\\TBWA ICELAND)
(SAVE A) LIFE INSURANCE – GENERALI (VML BUCHAREST)
#MAINFLAVOURENERGY – HELLMANN'S (EDELMAN TORONTO)
$HOPLIFTING – LAUT GEGEN NAZIS E.V. (JUNG VON MATT HAMBURG)
30UNDER30 – CHANGE THE REF (FOUNDERS MIAMI)
A CRY FOR HYDRATION – STUDENA (IMAGO OGILVY SOFIA)
A MINECRAFT MOVIE MEAL – MCDONALD'S (WIEDEN+KENNEDY NEW YORK)
A.I. IRRESPONSIBLY – BREWLANDER (BLKJ HAVAS SINGAPORE)
ADS IN MY PHONE CALL – SKINNY (COLENSO BBDO AUCKLAND)
AFFORDABLE MASTERPIECES – IKEA (MEMAC OGILVY DUBAI)
AN AGENT “COMO A GENTE” – MAGAZINE LUIZA (OGILVY SÃO PAULO)
ANIMAL ATTRACTION – GILEAD SCIENCES CANADA (THE LOCAL COLLECTIVE TORONTO)
AXA X SONITA: THE LONE VOICE – AXA (PUBLICIS CONSEIL PARIS)
BEDTIME DONATIONS – ROYAL SOCIETY FOR BLIND CHILDREN (INNOCEAN BERLIN)
BORN IN ROMA RENDEZVOUS IVORY COLLECTION / STUDIO 54 EXPERIENCE – VALENTINO BEAUTY (MAISON BETC PARIS)
BRING A BOOK TO LIFE – AMAZON (DROGA5 LONDON)
CANCER PREVENTION DISCOUNTS – BROADFORK PRODUCE (TANK WORLDWIDE MONTREAL)
CHEETOS FLAMIN' HOT DILL PICKLE MEMORABILIA – CHEETOS (GUT MIAMI)
CHUPA CHUPS IMPOSSIBLE – PERFETTI VAN MELLE (BBH LONDON)
COLORFOOD – AUCHAN (TBWA\\PARIS)
COLUMBIA – COLUMBIA SPORTSWEAR (COLUMBIA PORTLAND)
COVER IT – UNAIDS (AFRICA CREATIVE SÃO PAULO)
CRACKED ROYALE – CLASH ROYALE (DAVID NEW YORK)
CROSSES FOR CRISIS – RED CROSS (MUTANT LISBON)
CURFEW HOSTELS – TIGER BEER (LEPUB SINGAPORE)
CUSTOM BILLBOARDS – MERCADO LIVRE (GUT SÃO PAULO)
DEPARTURES – BOTICÁRIO (ALMAPBBDO SÃO PAULO)
DIRT IS GLORY – DIRT IS GOOD (FRANK LONDON)
DIRTY BUSINESS – CHANNEL 4 (4CREATIVE LONDON)
DISH – OPEN AI (ISLE OF ANY NEW WORK)
DON'T LOOK UP – STEADFAST (TBWA\\LINTAS MUMBAI)
DRAWN TO D&AD – D&AD (JONES KNOWLES RITCHIE LONDON)
DYING REVIEWS – HOSPICE NZ (MCCANN AUCKLAND)
ESCAPE VEHICLE – TOYOTA (OGILVY ATHENS)
EXPLORE YOUR STORY – COACH (FORSMAN & BODENFORS GOTHENBURG)
FANTASTIC KEYS – MARVEL / THE WALT DISNEY COMPANY FRANCE (MARCEL PARIS)
FANTASY HERD – MEADOW FRESH (MCCANN AUCKLAND)
FASCINATING – SHENZHEN TOURISM BUREAU (THE NINE SHENZHEN)
FATAL QUESTION – STREETDOCTORS (SAATCHI & SAATCHI LONDON)
FERTILIZER 2.5 – THAI HEALTH PROMOTION FOUNDATION (GREY BANGKOK)
FORESTS WITHOUT NAMES – HYUNDAI (BBDO NEW YORK)
FRAGMENTAL MEDAL – GATORADE (TOMBRAS OSLO)
GAME ON BALL – TRUE HOCKEY (DENTSU CREATIVE TORONTO)
GEORGIA, MISSOURI, PENNSYLVANIA – CHANGE THE REF (ALMA MIAMI)
GLOWING RELIEF – ALIVIA HEALTH (DE LA CRUZ OGILVY SAN JUAN)
GOOD DAYS – LILLY (WIEDEN+KENNEDY NEW YORK)
GOODBYE RX-7: SAYING FAREWELL TO A DEAR FRIEND – MAZDA (LUCK TOKYO)
HEALING ERA, THE HUSTLE, DELULU IS THE SOLULU – HANSA PILSENER (JOE PUBLIC JOHANNESBURG)
VOICE OF FOOD – AJINOMOTO CO. (DENTSU TOKYO)
HEAR IN HIJAB – WARDAH (DENTSU CREATIVE JAKARTA)
HEARAPY – SAMSUNG (LEO FRANKFURT)
HELP! – SANTALUCÍA (ORIOLVILLAR BARCELONA)
HERE TO STAY – MASTERCARD (MCCANN WARSAW)
ICEDENTITY – AGUILA LIGHT (DAVID BOGOTÁ)
IN GOOD TIME – UBER (MOTHER NEW YORK)
IT'S TIME TO STOP! – BINGO GROUP (VIA MEDIA SARAJEVO)
JELL-O-METER – JELL-O (GUT TORONTO)
JUAN GABRIEL – THE BALLAD OF ALBERTO – NETFLIX (MONKS MEXICO & NETFLIX MEXICO)
LAWS UNDER ATTACK – RED CROSS (TBWA\\RAAD DUBAI)
LIGHT HOLE – KODANSHA (HAKUHODO TOKYO)
LISTENING, STRUMMING, READING, DAYDREAMING – KITKAT (VML LONDON)
LONG LASTING PASSPORT – DARTY (PUBLICIS CONSEIL PARIS)
LOVE HURTS – VASELINE (OGILVY SINGAPORE)
LUTHER – KENDRICK LANAR (FELA LOS ANGELES)
M&M'S RICKTOK – M&M'S (BBDO NEW YORK)
MAFIA – PURGA STUDIO (GUT MEXICO)
MARSEILLE C'EST NOUS. – PUMA (WAY AGENCY PARIS)
MCDELIVERY SPEED CAMERA ADS – MCDONALD'S (SCHOLZ & FRIENDS HAMBURG)
MISSING LETTERS OF WORTH – L'ORÉAL (FP7 MCCANN DUBAI)
MOTHER STRIKE – SNACK JACK (HANAMI FOOD BANGKOK)
MOVING LANDSCAPES – BMW (SERVICEPLAN MUNICH & MADRID)
MY JAPAN RAILWAY – JR GROUP (DENTSU TOKYO)
NEVER OVER – ELI LILLY (WIEDEN+KENNEDY NEW YORK)
NO FRAME MISSED – APPLE (TBWA\\MEDIA ARTS LAB LOS ANGELES)
OM BDR – KFC (TBWA\\RAAD DUBAI)
OREO COWS FILM – OREO (VML NEW YORK)
OWNERS REUNIONS – PORSCHE LATIN AMERICA (THE COMMUNITY MIAMI)
PRESERVED PROMOS – ZIPLOC (VML NEW YORK)
PRICE PACKS – PENNY (SERVICEPLAN MUNICH)
PROTEST MARCH OF THE PENGUINS – PENGUINS INTERNATIONAL (RETHINK TORONTO)
PULL UP – OPEN AI (ISLE OF ANY NEW WORK)
R2R← – BRAHMA (AFRICA CREATIVE SÃO PAULO)
RACING, CLUB, VAMOS – COCA-COLA (GREY NEW YORK)
RAIL CLOCK – NETWORK RAIL (DESIGN BRIDGE AND PARTNERS LONDON)
RE-COMMERCE ATACAMA – VTEX & DESIERTO VESTIDO & FASHION REVOLUTION (ARTPLAN SÃO PAULO)
RENU VS THE CITY – ST. JUDE INDIA CHILDCARE CENTRES (OGILVY MUMBAI)
ROAD TEST ROYALE – THE GENERAL AUTO INSURANCE (BBDO ATLANTA)
ROOFTOP REVIVAL – HEINEKEN (LEPUB SINGAPORE)
RUN BACK THE MIRACLE – MICHELOB ULTRA (WIEDEN+KENNEDY NEW YORK)
SAMURAI – PURGA STUDIO (GUT MEXICO)
SAVINGS INDEX – NATWEST (INITIATIVE MEDIA LONDON)
SAWAAL UTHAO – TATA 1MG (HUMOUR ME NEW DELHI)
SCRATCH YOUR DATA – MERCADO LIBRE (GUT SÃO PAULO)
SEE A SEIZURE – JAZZ PHARMACEUTICALS (21GRAMS NEW YORK)
SHEEP HAPPENS – PENNY (SAINT ELMO'S MUNICH)
SILENT CLEANING – KAO BRANDS (WHATEVER TOKYO)
SIMPLY NKD™ THE RENAISSANCE OF SNACKING – SIMPLY NKD™ (GUT MIAMI)
SLIDE – APPLE (APPLE CUPERTINO)
SOCIALIZING BILLBOARDS – HEINEKEN (LEPUB SÃO PAULO)
SOSEGÁ – CERVEZAS ALHAMBRA (LLYC MADRID)
STELLA LOCAD GUIDES – STELLA ARTOIS (AB INBEV SÃO PAULO)
STEPH CURRY SHOOTS THE MOON – RANDOM HOUSE PUBLISHING GROUP (KNOWN NEW YORK)
STRANGER THINGS IN SEARCH – GOOGLE AND NETFLIX (GOOGLE MOUNTAIN VIEW)
SUFFERING – MUSÉE DE LA GRANDE GUERRE (BBDO PARIS)
TABLEAU – JOHN LEWIS (SOMESUCH LONDON)
TD FRACTIONAL WINDOW SHOPPING – TD (OGILVY TORONTO)
THE 58 YEAR OLD ROOKIE – OPELLA (MARTIN RICHMOND)
THE AREPA THAT UNITES – WARNER MUSIC COLOMBIA (BUENTIPO BOGOTÁ)
THE BIG REDEMPTION – FRONTIER AIRLINES (BARKLEYOKRP KANSAS CITY)
THE CATRACE – DISTANCE × STRAVA (BETC PARIS)
THE COOLEST IHRAM – SAUDIA (LANDOR DUBAI)
THE FANDOM COMEBACK – TECATE (LEPUB MEXICO CITY)
THE FINAL COPY OF ILON SPECHT – L'OREAL (MCCANN PARIS)
THE GRIT & THE GLITTER – LONDON MUSEUM (UNCOMMON CREATIVE STUDIO LONDON)
THE KAPRAO CRIMINALS – KFC THAILAND (WOLF BKK BANGKOK)
THE LEAST MOST INTERESTING MAN – DOS EQUIS (LEPUB NEW YORK)
THE MAGAZINE IN ALL FORMATS – DIN (DEUTSCHES INSTITUT FÜR NORMUNG BERLIN)
THE MEXICAN DREAM – CERVEZA INDIO (OGILVY MEXICO CITY)
THE MISSING MANAGERS – XBOX (MCCANN LONDON)
THE MISSING WORD DICTIONARY – VISIONING BEYOND VIOLENCE (FCB HEALTH NEW YORK)
THE SHAKESPEARE BIC – BIC BRASIL (VML SÃO PAULO)
THE SHOOTING – LA UNIÓN NEWSPAPER (GREY MEXICO)
THE TREASURE HUNT – MINISTRY FOR EQUALITY (OGILVY MADRID)
THE TRIANGLE THEORY – DORITOS (ALMAPBBDO SÃO PAULO)
THE WIZARD OF OZ AT SPHERE – SPHERE STUDIOS (SPHERE ENTERTAINMENT BURBANK)
TRIP – OPEN AI (ISLE OF ANY NEW WORK)
TWO-WAY DEAL – CLASH OF CLANS (DAVID NEW YORK)
UKRAINE AIR RAID ALERTS – UNICEF (UNITED IMAGINATIONS HELSINKI)
UNLOVED – INTERMARCHÉ (ROMANCE PARIS)
UNTAUGHT HISTORY EDITION – ANNAHAR (IMPACT BBDO DUBAI)
UV TATTOO TO LEARN – ISDIN (HAVAS PLAY BARCELONA)
VISION CONSTANTLY PULSED: SIGHT BEYOND SEEING – HYUNDAI (PAULUS SEOUL)
WESTERN – PURGA STUDIO (GUT MIAMI)
WHEREVER LIFE GOES – IKEA (NOA | ÅKESTAM HOLST / STOCKHOLM)
WHO'S WAITING FOR YOU? FILM – CERVEZA VICTORIA (WIEDEN+KENNEDY MEXICO)
WIFI INVASION – WAOO (UNCLE GREY COPENHAGEN)
`;

const FAVORITES_KEY = 'cannes_deck_favorites_2026';
const FAVORITES_USER_KEY = 'cannes_deck_user_token_2026';
const FAVORITES_API_URL = '/api/cannes/favorites';
const GEMINI_API_KEY = process.env.GEMINI_API_KEY || '';
const GEMINI_MODEL = 'gemini-2.5-flash';
const QUICK_PROMPTS = [
  'Creative Hook',
  'Strategy Breakdown',
  'Why did this win?',
  'Similar campaigns'
];

const LION_CATEGORY_FILTERS = [
  'Film',
  'Outdoor',
  'Print & Publishing',
  'PR',
  'Design',
  'Entertainment',
  'Media',
  'Direct',
  'Titanium',
  'Innovation',
  'Creative',
  'Craft',
  'Radio & Audio',
  'Pharma & Health',
  'Luxury',
  'Glass',
  'Social & Creator',
  'SDGs'
];

function readStoredFavorites() {
  try {
    const saved = localStorage.getItem(FAVORITES_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch {
    return [];
  }
}

function getFavoritesUserToken() {
  let token = localStorage.getItem(FAVORITES_USER_KEY);
  if (!token) {
    const entropy = Math.random().toString(36).slice(2);
    token = `u-${entropy}${Date.now().toString(36)}`;
    localStorage.setItem(FAVORITES_USER_KEY, token);
  }
  return token;
}

function normalizeLionCategory(subcategory) {
  if (!subcategory) return '';
  const value = subcategory.toUpperCase();
  if (value.includes('TITANIUM')) return 'Titanium';
  if (value.includes('OUTDOOR')) return 'Outdoor';
  if (value.includes('PRINT')) return 'Print & Publishing';
  if (value.includes('PR') && !value.includes('PRINT')) return 'PR';
  if (value.includes('DESIGN')) return 'Design';
  if (value.includes('ENTERTAINMENT') || value.includes('GAMING') || value.includes('SPORT') || value.includes('MUSIC')) return 'Entertainment';
  if (value.includes('MEDIA')) return 'Media';
  if (value.includes('DIRECT')) return 'Direct';
  if (value.includes('INNOVATION')) return 'Innovation';
  if (value.includes('CREATIVE')) return 'Creative';
  if (value.includes('DIGITAL CRAFT') || value.includes('FILM CRAFT') || value.includes('INDUSTRY CRAFT')) return 'Craft';
  if (value.includes('RADIO') || value.includes('AUDIO')) return 'Radio & Audio';
  if (value.includes('PHARMA') || value.includes('HEALTH')) return 'Pharma & Health';
  if (value.includes('LUXURY')) return 'Luxury';
  if (value.includes('GLASS')) return 'Glass';
  if (value.includes('SOCIAL')) return 'Social & Creator';
  if (value.includes('SUSTAINABLE') || value.includes('SDG')) return 'SDGs';
  if (value.includes('FILM')) return 'Film';
  return '';
}

function inferLionCategory(title = '', brand = '', agency = '') {
  const value = `${title} ${brand} ${agency}`.toUpperCase();
  if (/(CANCER|HEALTH|PHARMA|HOSPICE|HOSPITAL|KIDNEY|SEIZURE|VIAGRA|CERAVE|NOVARTIS|LALCEC|AUTISM|TUPHARMA|OPPELLA|GILEAD|ST\. JUDE|EQUALITY HEALTH|LADYWELL|THE ORDINARY)/.test(value)) return 'Pharma & Health';
  if (/(GUCCI|TIFFANY|MONCLER|VALENTINO|PORSCHE|COACH|REALREAL|LUXE)/.test(value)) return 'Luxury';
  if (/(OCEAN|FOREST|SUSTAINABLE|CLIMATE|SICK LEAVE|RED CROSS|UNICEF|UNAIDS|WOMEN FOR CHANGE|PENGUINS|IUCN)/.test(value)) return 'SDGs';
  if (/(GIRL|WOMEN|RACISM|BLACK|HIJAB|GENDER|NIGRUM|GLASS|PERIOD|KOTEX|SOMOS MARTINA)/.test(value)) return 'Glass';
  if (/(JINGLE|RADIO|SOUND|ALARM|VOICE|LISTEN|HEAR|FLUTE|AUDIO|STING)/.test(value)) return 'Radio & Audio';
  if (/(GAME|GAMING|CLASH|MINECRAFT|TETRIS|EA SPORTS|SKATE|XBOX|FC|FOOTBALL|RUGBY|F1|SPORT|WATCH PARTY|CURRY|OLYMPIC|CLUB)/.test(value)) return 'Entertainment';
  if (/(FILM|SHOT|CAMERA|HALFTIME SHOW|COMMERCIAL|DOCUMENTARY|NETFLIX|APPLE TV|SPHERE|WIZARD OF OZ|WESTERN|SAMURAI)/.test(value)) return 'Film';
  if (/(BILLBOARD|OOH|OUTDOOR|OUTSIDE|ROOFTOP|BARCODE|DOORBELL ADS|SPEED CAMERA|POSTER|STREET|STORES|SHOWROOM)/.test(value)) return 'Outdoor';
  if (/(BOOK|MAGAZINE|NEWSPAPER|DICTIONARY|FAX|PRINT|PUBLISHING|ARTICLE|LEAF|REPORT|EDITION)/.test(value)) return 'Print & Publishing';
  if (/(AI|A\.I\.|OPEN AI|GOOGLE|CODE|ADAPTIVE|PROJECT|INNOVATION|APP|DATA|SEARCH|WIFI|PASSPORT|ACCESSIBLE|TILT)/.test(value)) return 'Innovation';
  if (/(IDENTITY|REBRAND|DESIGN|LOGO|PACK|PACKAGING|COLORFOOD|RAIL CLOCK|CONDENSED|CRAFTMAN|TINY COFFEE|CRAFT)/.test(value)) return 'Design';
  if (/(TIKTOK|SOCIAL|FACEBOOK|CREATOR|INFLUENCER|REVIEWS|RICKTOK)/.test(value)) return 'Social & Creator';
  if (/(MEDIA|ADS|AD|PRIME TIME|SUPER BOWL|SEARCH|COUPON|SCHEDULE|CURRENCY|PHONE CALL)/.test(value)) return 'Media';
  if (/(DONATE|DONATION|COUPON|RECEIPT|DELIVER|DELIVERY|DIRECT|INDEX|PRICE|PROMO|SHOP|SHOPPING|COMMERCE|SALE)/.test(value)) return 'Direct';
  if (/(HEIST|PR|PUBLIC|PRESS|CRISIS|PROTEST|CURFEW|MISSING|LAWS UNDER ATTACK|CROSSES)/.test(value)) return 'PR';
  if (/(CRAFT|TINY|SHOOTING|SILENT EDITION|FILET-O-FISH|TABLEAU|HANDMADE|ANIMATION)/.test(value)) return 'Craft';
  return 'Creative';
}

function getVideoInfo(winner) {
  if (!winner) return { type: 'none' };
  const upperTitle = winner.title.toUpperCase().trim();
  const directMatch = videoDb[upperTitle] || videoDb[winner.title];
  if (directMatch) return directMatch;

  const cleanTitle = upperTitle.replace(/[^A-Z0-9 ]/g, '').trim();
  for (const [key, value] of Object.entries(videoDb)) {
    if (key.replace(/[^A-Z0-9 ]/g, '').trim() === cleanTitle) {
      return value;
    }
  }

  return { type: 'youtube-search', query: `${winner.title} ${winner.brand} Cannes Lions 2026 case study` };
}

function getSourceName(url) {
  if (!url) return 'source';
  try {
    const host = new URL(url).hostname.replace(/^www\./, '');
    if (host.includes('youtube')) return 'YouTube';
    if (host.includes('vimeo')) return 'Vimeo';
    if (host.includes('ogilvy')) return 'Ogilvy';
    if (host.includes('lbbonline')) return 'LBBOnline';
    if (host.includes('oneclub')) return 'OneClub';
    if (host.includes('dandad')) return 'D&AD';
    if (host.includes('latinspots')) return 'LatinSpots';
    return host.split('.')[0].replace(/-/g, ' ');
  } catch {
    return 'source';
  }
}

// Helper to parse the raw text from lovetheworkmore.com
function parseWinners() {
  const lines = RAW_WINNERS_TEXT.split('\n');
  const winners = [];
  let currentCategory = 'GRAND PRIX / TITANIUM';

  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    // Check for Category headers
    if (trimmed === 'GRAND PRIX / TITANIUM' || trimmed === 'GOLD' || trimmed === 'SILVER' || trimmed === 'BRONZE') {
      currentCategory = trimmed;
      return;
    }

    // Try parsing winner: "[SUB] TITLE – BRAND (AGENCY CITY)" or variation
    // Note: handling both normal hyphen "-" and en-dash "–"
    if (trimmed.includes('–') || trimmed.includes(' - ')) {
      const isEnDash = trimmed.includes('–');
      const parts = trimmed.split(isEnDash ? '–' : ' - ');
      
      let leftPart = parts[0].trim();
      let rightPart = parts.slice(1).join(isEnDash ? '–' : ' - ').trim();

      // Extract Subcategory like [TITANIUM GRAND PRIX]
      let subcategory = '';
      const subMatch = leftPart.match(/^\[(.*?)\]/);
      if (subMatch) {
        subcategory = subMatch[1];
        leftPart = leftPart.replace(/^\[.*?\]/, '').trim();
      }

      // Extract Agency and City inside (...) at the very end
      let agency = '';
      let city = '';
      let brand = rightPart;

      const parenMatch = rightPart.match(/\(([^)]+)\)$/);
      if (parenMatch) {
        const fullAgencyStr = parenMatch[1];
        brand = rightPart.replace(/\s*\([^)]+\)$/, '').trim();
        
        // Try parsing agency and location (often slash or space separated)
        if (fullAgencyStr.includes('\\') || fullAgencyStr.includes('/') || fullAgencyStr.includes(' ')) {
          agency = fullAgencyStr;
        } else {
          agency = fullAgencyStr;
        }
      }

      // Add to database
      winners.push({
        id: `w-${index}`,
        title: leftPart,
        brand: brand,
        agency: agency || 'Direct',
        category: currentCategory,
        subcategory: subcategory,
        lionCategory: normalizeLionCategory(subcategory) || inferLionCategory(leftPart, brand, agency),
        originalString: trimmed
      });
    }
  });

  return winners;
}

export default function App() {
  const winnersList = useMemo(() => parseWinners(), []);
  
  // State management
  const [selectedCategory, setSelectedCategory] = useState('ALL');
  const [selectedLionCategory, setSelectedLionCategory] = useState('ALL');
  const [showSavedOnly, setShowSavedOnly] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoplay, setAutoplay] = useState(false);
  const [autoplayInterval, setAutoplayInterval] = useState(15); // in seconds
  const [theaterMode, setTheaterMode] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isVirtualFullscreen, setIsVirtualFullscreen] = useState(false);
  const [favorites, setFavorites] = useState(readStoredFavorites);
  const [exportCopyStatus, setExportCopyStatus] = useState('');
  
  // Chatbot / Gemini Integration State
  const [chatMessages, setChatMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [aiError, setAiError] = useState(null);

  // Auto Scroll logic
  const timerRef = useRef(null);
  const favoritesLoadedRef = useRef(false);
  const favoriteSyncTimerRef = useRef(null);

  const awardCounts = useMemo(() => {
    const counts = { ALL: winnersList.length };
    winnersList.forEach(w => {
      counts[w.category] = (counts[w.category] || 0) + 1;
    });
    return counts;
  }, [winnersList]);

  const lionCategoryCounts = useMemo(() => {
    const counts = { ALL: winnersList.filter(w => w.lionCategory).length };
    winnersList.forEach(w => {
      if (w.lionCategory) counts[w.lionCategory] = (counts[w.lionCategory] || 0) + 1;
    });
    return counts;
  }, [winnersList]);

  // Filtered winners based on active award, Lions category, saved state, and search query
  const filteredWinners = useMemo(() => {
    return winnersList.filter(w => {
      const matchCategory = selectedCategory === 'ALL' || w.category === selectedCategory;
      const matchLionCategory = selectedLionCategory === 'ALL' || w.lionCategory === selectedLionCategory;
      const matchSaved = !showSavedOnly || favorites.includes(w.id);
      const cleanSearch = searchQuery.toLowerCase();
      const matchSearch = !searchQuery || 
        w.title.toLowerCase().includes(cleanSearch) ||
        w.brand.toLowerCase().includes(cleanSearch) ||
        w.agency.toLowerCase().includes(cleanSearch) ||
        (w.subcategory && w.subcategory.toLowerCase().includes(cleanSearch));
      return matchCategory && matchLionCategory && matchSaved && matchSearch;
    });
  }, [winnersList, selectedCategory, selectedLionCategory, showSavedOnly, favorites, searchQuery]);

  // Adjust current index if it falls out of bound of the filtered array
  useEffect(() => {
    if (currentIndex >= filteredWinners.length && filteredWinners.length > 0) {
      setCurrentIndex(0);
    }
  }, [filteredWinners, currentIndex]);

  const activeWinner = filteredWinners[currentIndex] || filteredWinners[0] || null;

  // Save favorites locally for offline/fallback persistence.
  useEffect(() => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  }, [favorites]);

  // Load server-side favorites once, then merge them with any local favorites.
  useEffect(() => {
    let cancelled = false;
    const token = getFavoritesUserToken();
    fetch(FAVORITES_API_URL, { headers: { 'X-User-Token': token } })
      .then(response => response.ok ? response.json() : Promise.reject(new Error('Favorites API unavailable')))
      .then(serverFavorites => {
        if (cancelled || !Array.isArray(serverFavorites)) return;
        setFavorites(localFavorites => Array.from(new Set([...localFavorites, ...serverFavorites])));
      })
      .catch(() => {
        // Local storage remains the fallback when the API is unreachable.
      })
      .finally(() => {
        if (!cancelled) favoritesLoadedRef.current = true;
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Debounce writes to the server so rapid heart toggles settle before syncing.
  useEffect(() => {
    if (!favoritesLoadedRef.current) return;
    if (favoriteSyncTimerRef.current) clearTimeout(favoriteSyncTimerRef.current);
    favoriteSyncTimerRef.current = setTimeout(() => {
      const token = getFavoritesUserToken();
      fetch(FAVORITES_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-Token': token
        },
        body: JSON.stringify(favorites)
      }).catch(() => {
        // Local storage already contains the latest state.
      });
    }, 500);
    return () => {
      if (favoriteSyncTimerRef.current) clearTimeout(favoriteSyncTimerRef.current);
    };
  }, [favorites]);

  // Autoplay effect
  useEffect(() => {
    if (autoplay && filteredWinners.length > 1) {
      timerRef.current = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % filteredWinners.length);
      }, autoplayInterval * 1000);
    } else {
      if (timerRef.current) clearInterval(timerRef.current);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [autoplay, autoplayInterval, filteredWinners]);

  // Dynamic Browser-Level Fullscreen with Virtual Sandbox Fallback
  const toggleFullscreen = () => {
    if (isVirtualFullscreen || document.fullscreenElement) {
      // Exit fullscreen mode gracefully
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
      }
      setIsFullscreen(false);
      setIsVirtualFullscreen(false);
    } else {
      // Try HTML5 Browser Native standard fullscreen
      document.documentElement.requestFullscreen()
        .then(() => {
          setIsFullscreen(true);
          setIsVirtualFullscreen(false);
        })
        .catch(() => {
          // Fall back seamlessly to browser-window virtual fullscreen inside sandboxed iframe limits
          setIsVirtualFullscreen(true);
          setIsFullscreen(true);
        });
    }
  };

  // Sync isFullscreen state on browser-native exit events (e.g. Escape key)
  useEffect(() => {
    const handleFullscreenChange = () => {
      const activeNative = !!document.fullscreenElement;
      if (!activeNative && !isVirtualFullscreen) {
        setIsFullscreen(false);
      }
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, [isVirtualFullscreen]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        return; // ignore keyboard hotkeys when typing in search or AI prompt fields
      }
      if (e.key === 'ArrowRight') {
        handleNext();
      } else if (e.key === 'ArrowLeft') {
        handlePrev();
      } else if (e.key === ' ') {
        e.preventDefault();
        setAutoplay(prev => !prev);
      } else if (e.key === 't' || e.key === 'T') {
        setTheaterMode(prev => !prev);
      } else if (e.key === 'f' || e.key === 'F') {
        toggleFullscreen();
      } else if (e.key === 'Escape' && isVirtualFullscreen) {
        setIsVirtualFullscreen(false);
        setIsFullscreen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [filteredWinners.length, isVirtualFullscreen]);

  const handleNext = () => {
    if (filteredWinners.length === 0) return;
    setCurrentIndex(prev => (prev + 1) % filteredWinners.length);
  };

  const handlePrev = () => {
    if (filteredWinners.length === 0) return;
    setCurrentIndex(prev => (prev - 1 + filteredWinners.length) % filteredWinners.length);
  };

  const handleFavoriteToggle = (id) => {
    setFavorites(prev => 
      prev.includes(id) ? prev.filter(fId => fId !== id) : [...prev, id]
    );
  };

  // Construct search embed query to find corresponding Case Study automatically
  const getEmbedUrl = (winner) => {
    if (!winner) return '';
    const videoInfo = getVideoInfo(winner);
    if (videoInfo.type === 'youtube') {
      return `https://www.youtube.com/embed/${videoInfo.id}?autoplay=1&mute=1&enablejsapi=1&rel=0`;
    }
    if (videoInfo.type === 'vimeo') {
      return `https://player.vimeo.com/video/${videoInfo.id}?autoplay=1&muted=1&title=0&byline=0&portrait=0`;
    }
    if (videoInfo.type === 'external') {
      return videoInfo.url || videoInfo.id || '';
    }
    if (videoInfo.type === 'youtube-search') {
      return `https://www.youtube.com/embed?listType=search&list=${encodeURIComponent(videoInfo.query)}&autoplay=0&mute=1&rel=0`;
    }
    return '';
  };

  // Dynamic direct link search helper
  const getSearchUrl = (winner) => {
    if (!winner) return '';
    const videoInfo = getVideoInfo(winner);
    if (videoInfo.type === 'youtube') return `https://www.youtube.com/watch?v=${videoInfo.id}`;
    if (videoInfo.type === 'vimeo') return `https://vimeo.com/${videoInfo.id}`;
    if (videoInfo.type === 'external') return videoInfo.url || videoInfo.id || '';
    const query = videoInfo.query || `${winner.title} ${winner.brand} Cannes Lions case study`;
    return `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`;
  };

  const getExportVideoLink = (winner) => {
    if (!winner) return '';
    const videoInfo = getVideoInfo(winner);
    if (videoInfo.type === 'youtube') return `https://www.youtube.com/watch?v=${videoInfo.id}`;
    if (videoInfo.type === 'vimeo') return `https://vimeo.com/${videoInfo.id}`;
    if (videoInfo.type === 'external') return videoInfo.url || videoInfo.id || '';
    return '';
  };

  const savedWinners = useMemo(() => {
    const savedIds = new Set(favorites);
    return winnersList.filter(winner => savedIds.has(winner.id));
  }, [favorites, winnersList]);

  const savedExportRows = useMemo(() => {
    return savedWinners.map(winner => ({
      category: winner.lionCategory || winner.subcategory || '',
      campaignName: winner.title,
      brand: winner.brand,
      agency: winner.agency,
      awardLevel: winner.category,
      videoLink: getExportVideoLink(winner)
    }));
  }, [savedWinners]);

  const escapeCsvValue = (value) => {
    const stringValue = String(value ?? '');
    return /[",\n\r]/.test(stringValue) ? `"${stringValue.replace(/"/g, '""')}"` : stringValue;
  };

  const getSavedCsv = () => {
    const headers = ['Category', 'Campaign Name', 'Brand', 'Agency', 'Award Level', 'Video Link'];
    const rows = savedExportRows.map(row => [
      row.category,
      row.campaignName,
      row.brand,
      row.agency,
      row.awardLevel,
      row.videoLink
    ]);
    return [headers, ...rows].map(row => row.map(escapeCsvValue).join(',')).join('\n');
  };

  const getSavedTextTable = () => {
    if (savedExportRows.length === 0) return 'No saved Cannes Lions 2026 cases.';
    const escapeTableValue = (value) => String(value ?? '').replace(/\|/g, '\\|');
    const headers = ['Category', 'Campaign Name', 'Brand', 'Agency', 'Award Level', 'Video Link'];
    const divider = headers.map(() => '---');
    const rows = savedExportRows.map(row => [
      row.category,
      row.campaignName,
      row.brand,
      row.agency,
      row.awardLevel,
      row.videoLink
    ]);
    return [headers, divider, ...rows]
      .map(row => `| ${row.map(escapeTableValue).join(' | ')} |`)
      .join('\n');
  };

  const getSavedExportFilename = () => {
    const date = new Date().toISOString().slice(0, 10);
    return `cannes-lions-2026-saved-${date}.csv`;
  };

  const handleDownloadSavedCsv = () => {
    if (savedExportRows.length === 0) return;
    const blob = new Blob([getSavedCsv()], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = getSavedExportFilename();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleCopySavedExport = async () => {
    const exportText = getSavedTextTable();
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(exportText);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = exportText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setExportCopyStatus('Copied');
      window.setTimeout(() => setExportCopyStatus(''), 1600);
    } catch (err) {
      console.error('Failed to copy saved export', err);
      setExportCopyStatus('Copy failed');
      window.setTimeout(() => setExportCopyStatus(''), 2200);
    }
  };

  // Copy shareable code
  const handleCopyCode = () => {
    if (!activeWinner) return;
    const textToCopy = `[CANNES 2026 WINNER] ${activeWinner.title} - ${activeWinner.brand} (${activeWinner.agency}) [Award: ${activeWinner.category}]`;
    
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      alert('Campaign description copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy', err);
    }
    document.body.removeChild(textarea);
  };

  const getCampaignContext = (winner) => {
    if (!winner) return '';
    const videoInfo = getVideoInfo(winner);
    return [
      `Campaign name: ${winner.title}`,
      `Brand: ${winner.brand}`,
      `Agency: ${winner.agency}`,
      `Award level: ${winner.category}`,
      `Cannes category: ${winner.lionCategory || winner.subcategory || 'General'}`,
      `Description/source entry: ${winner.originalString}`,
      `Video mapping: ${videoInfo.type}${videoInfo.id ? ` (${videoInfo.id})` : ''}${videoInfo.url ? ` (${videoInfo.url})` : ''}`
    ].join('\n');
  };

  // Gemini API integration with exponential backoff.
  const callGeminiWithBackoff = async (prompt, retries = 5, delay = 1000) => {
    if (!GEMINI_API_KEY) {
      throw new Error('Gemini API key is not configured for this build.');
    }
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${GEMINI_MODEL}:generateContent?key=${encodeURIComponent(GEMINI_API_KEY)}`;
    
    const payload = {
      contents: [{ parts: [{ text: prompt }] }],
      systemInstruction: {
        parts: [{
          text: `Cannes Lions 2026`
        }]
      }
    };

    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          const data = await response.json();
          return data.candidates?.[0]?.content?.parts?.[0]?.text || "No insights found.";
        }
        if (response.status >= 400 && response.status < 500) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData?.error?.message || 'Gemini rejected the request.');
        }
      } catch (err) {
        if (i === retries - 1 || /Gemini rejected/.test(err.message)) {
          throw err;
        }
      }
      // Wait for backoff
      await new Promise(resolve => setTimeout(resolve, delay));
      delay *= 2; // exponential scaling
    }
    throw new Error("Unable to connect to Gemini. Please try again shortly.");
  };

  // Submit chat to the Gemini AI assistant
  const handleSendChatMessage = async (presetText = null) => {
    const messageToSend = presetText || inputMessage;
    if (!messageToSend.trim() || !activeWinner) return;

    const newMessages = [...chatMessages, { sender: 'user', text: messageToSend }];
    setChatMessages(newMessages);
    setInputMessage('');
    setIsAiLoading(true);
    setAiError(null);

    const fullPrompt = `Selected Cannes Lions 2026 campaign context:
${getCampaignContext(activeWinner)}

User question:
${messageToSend}`;

    try {
      const responseText = await callGeminiWithBackoff(fullPrompt);
      setChatMessages(prev => [...prev, { sender: 'gemini', text: responseText }]);
    } catch (err) {
      setAiError(err.message || 'Gemini is unavailable.');
    } finally {
      setIsAiLoading(false);
    }
  };

  // Reset chatbot chat when campaign changes
  useEffect(() => {
    if (activeWinner) {
      setChatMessages([
        { 
          sender: 'gemini', 
          text: `I am ready to analyze ${activeWinner.title}. Ask a specific question or use a quick prompt.` 
        }
      ]);
    }
  }, [activeWinner]);

  const activeVideoInfo = getVideoInfo(activeWinner);
  const activeEmbedUrl = getEmbedUrl(activeWinner);
  const activeSourceUrl = getSearchUrl(activeWinner);
  const activeSourceName = getSourceName(activeSourceUrl);
  const videoMappingCount = Object.keys(videoDb).length;
  const savedCount = favorites.length;
  const selectedPosition = filteredWinners.findIndex(w => activeWinner && w.id === activeWinner.id) + 1;

  const getAwardTone = (category) => {
    if (category.includes('GRAND PRIX')) return 'kb-award-grand';
    if (category === 'GOLD') return 'kb-award-gold';
    if (category === 'SILVER') return 'kb-award-silver';
    if (category === 'BRONZE') return 'kb-award-bronze';
    return 'kb-award-default';
  };

  return (
    <div className={`kb-cannes-app ${isVirtualFullscreen ? 'kb-fullscreen' : ''}`}>
      <style>{`
        @font-face {
          font-family: "eToro";
          src: url("/investors/fonts/eToro-Variable.woff2") format("woff2");
          font-weight: 100 900;
          font-display: swap;
        }
        html, body, #root { min-height: 100%; background: #000021; }
        body { margin: 0; overflow: auto !important; }
        .kb-cannes-app {
          --kb-navy: #000021;
          --kb-afterhours: #10110E;
          --kb-cream: #ECEAD1;
          --kb-green: #13C636;
          --kb-signal: #6DFF8A;
          --kb-muted: rgba(236,234,209,.64);
          --kb-faint: rgba(236,234,209,.36);
          --kb-line: rgba(236,234,209,.12);
          min-height: 100vh;
          color: var(--kb-cream);
          background:
            radial-gradient(circle at 50% 28%, rgba(19,198,54,.16), transparent 28rem),
            radial-gradient(circle at 18% 8%, rgba(109,255,138,.08), transparent 22rem),
            linear-gradient(180deg, #000021 0%, #050612 44%, #10110E 100%);
          font-family: "eToro", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
          letter-spacing: 0;
          position: relative;
          isolation: isolate;
        }
        .kb-video-stage {
          position: sticky;
          top: 88px;
          z-index: 8;
          margin-bottom: 18px;
        }
        .kb-video-shell {
          width: 100%;
          aspect-ratio: 16 / 9;
          border: 1px solid rgba(236,234,209,.18);
          border-radius: 12px;
          overflow: hidden;
          background: rgba(0,0,33,.76);
          box-shadow: 0 36px 120px rgba(0,0,0,.56), 0 0 0 1px rgba(109,255,138,.08);
          position: relative;
        }
        .kb-video-shell::after {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          box-shadow: inset 0 0 120px rgba(0,0,33,.22);
        }
        .kb-video-frame {
          width: 100%;
          height: 100%;
          border: 0;
          display: block;
          animation: kbVideoIn 220ms ease-out both;
        }
        .kb-external-video {
          height: 100%;
          display: grid;
          place-items: center;
          text-align: center;
          padding: 32px;
          background:
            linear-gradient(135deg, rgba(109,255,138,.10), transparent 40%),
            rgba(0,0,33,.92);
        }
        .kb-external-video a { pointer-events: auto; }
        @keyframes kbVideoIn {
          from { opacity: .55; transform: scale(.992); }
          to { opacity: 1; transform: scale(1); }
        }
        .kb-page-layer {
          position: relative;
          z-index: 2;
          min-height: 100vh;
          padding: 18px clamp(16px, 3vw, 42px) 64px;
        }
        .kb-topbar {
          position: sticky;
          top: 0;
          z-index: 30;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 14px 16px;
          border: 1px solid var(--kb-line);
          border-radius: 14px;
          background: rgba(0,0,33,.66);
          backdrop-filter: blur(22px) saturate(1.12);
          box-shadow: 0 18px 42px rgba(0,0,0,.22);
        }
        .kb-logo { height: 30px; width: auto; display: block; }
        .kb-kicker {
          font-size: 11px;
          line-height: 1;
          color: var(--kb-signal);
          text-transform: uppercase;
          font-weight: 650;
        }
        .kb-title {
          margin: 0;
          font-size: clamp(24px, 4vw, 58px);
          line-height: .98;
          font-weight: 620;
          max-width: 760px;
          letter-spacing: 0;
        }
        .kb-subcopy {
          margin: 10px 0 0;
          color: var(--kb-muted);
          max-width: 70ch;
          font-size: 15px;
          line-height: 1.6;
        }
        .kb-hero {
          padding: 36px 0 24px;
          max-width: 1040px;
        }
        .kb-chip, .kb-filter, .kb-icon-btn, .kb-card, .kb-search {
          border: 1px solid var(--kb-line);
          background: rgba(16,17,14,.42);
          backdrop-filter: blur(18px) saturate(1.12);
        }
        .kb-chip {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: var(--kb-muted);
          border-radius: 999px;
          padding: 7px 10px;
          font-size: 12px;
        }
        .kb-dot { width: 7px; height: 7px; border-radius: 999px; background: var(--kb-green); box-shadow: 0 0 18px var(--kb-green); }
        .kb-workspace {
          display: grid;
          grid-template-columns: 300px minmax(0, 1fr) 320px;
          gap: 18px;
          align-items: start;
        }
        .kb-left-sidebar,
        .kb-agent-panel {
          position: sticky;
          top: 88px;
          z-index: 14;
          max-height: calc(100vh - 108px);
          overflow: auto;
          border: 1px solid var(--kb-line);
          border-radius: 12px;
          background:
            linear-gradient(180deg, rgba(109,255,138,.055), transparent 38%),
            rgba(0,0,33,.70);
          backdrop-filter: blur(24px) saturate(1.1);
          box-shadow: 0 20px 60px rgba(0,0,0,.28);
        }
        .kb-left-sidebar {
          padding: 14px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          overflow: hidden;
        }
        .kb-agent-panel {
          padding: 16px;
        }
        .kb-panel-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          margin-bottom: 12px;
        }
        .kb-panel-title {
          margin: 0;
          font-size: 12px;
          line-height: 1;
          color: var(--kb-faint);
          text-transform: uppercase;
          font-weight: 680;
        }
        .kb-filter-group + .kb-filter-group { margin-top: 18px; }
        .kb-filter-panel {
          flex: 0 0 auto;
          overflow: auto;
          max-height: 46vh;
          padding-right: 2px;
        }
        .kb-filter-stack {
          display: grid;
          gap: 7px;
        }
        .kb-search-wrap { position: relative; min-width: 0; width: 100%; }
        .kb-search-icon { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); color: var(--kb-faint); width: 16px; height: 16px; }
        .kb-search {
          width: 100%;
          border-radius: 10px;
          padding: 10px 14px 10px 38px;
          color: var(--kb-cream);
          outline: none;
          font-size: 13px;
        }
        .kb-search:focus { border-color: rgba(109,255,138,.55); box-shadow: 0 0 0 3px rgba(109,255,138,.08); }
        .kb-filter, .kb-icon-btn {
          min-height: 38px;
          border-radius: 10px;
          color: var(--kb-muted);
          padding: 8px 12px;
          font-size: 12px;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          justify-content: space-between;
          transition: transform 180ms ease-out, border-color 180ms ease-out, background 180ms ease-out, color 180ms ease-out;
        }
        .kb-filter {
          width: 100%;
        }
        .kb-filter:hover, .kb-icon-btn:hover { transform: translateY(-1px); color: var(--kb-cream); border-color: rgba(109,255,138,.38); }
        .kb-filter.is-active, .kb-icon-btn.is-active {
          background: rgba(19,198,54,.16);
          color: var(--kb-signal);
          border-color: rgba(109,255,138,.48);
        }
        .kb-export-actions {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 7px;
          margin-top: 8px;
        }
        .kb-export-btn {
          min-height: 34px;
          border-radius: 9px;
          border: 1px solid rgba(236,234,209,.12);
          background: rgba(0,0,33,.36);
          color: var(--kb-muted);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          padding: 8px 9px;
          font-size: 11px;
          line-height: 1;
          transition: transform 180ms ease-out, border-color 180ms ease-out, background 180ms ease-out, color 180ms ease-out;
        }
        .kb-export-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          color: var(--kb-signal);
          border-color: rgba(109,255,138,.38);
          background: rgba(19,198,54,.10);
        }
        .kb-export-btn:disabled {
          cursor: not-allowed;
          opacity: .42;
        }
        .kb-export-status {
          margin-top: 7px;
          color: var(--kb-signal);
          font-size: 11px;
          line-height: 1;
          text-align: center;
        }
        .kb-count { color: var(--kb-faint); font-variant-numeric: tabular-nums; }
        .kb-center-column {
          min-width: 0;
        }
        .kb-results-head {
          display: flex;
          align-items: end;
          justify-content: space-between;
          gap: 14px;
          margin: 4px 0 14px;
          color: var(--kb-muted);
          font-size: 12px;
        }
        .kb-campaign-list-wrap {
          min-height: 260px;
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          gap: 9px;
          border-top: 1px solid var(--kb-line);
          padding-top: 12px;
        }
        .kb-campaign-list {
          min-height: 0;
          overflow: auto;
          display: grid;
          gap: 7px;
          padding-right: 2px;
        }
        .kb-campaign-item {
          width: 100%;
          min-height: 58px;
          border: 1px solid rgba(236,234,209,.10);
          border-radius: 10px;
          background: rgba(16,17,14,.28);
          color: var(--kb-muted);
          padding: 9px 10px;
          display: grid;
          grid-template-columns: minmax(0, 1fr) auto;
          gap: 8px;
          text-align: left;
          transition: transform 180ms ease-out, border-color 180ms ease-out, background 180ms ease-out, color 180ms ease-out;
        }
        .kb-campaign-item:hover {
          transform: translateY(-1px);
          border-color: rgba(109,255,138,.34);
          color: var(--kb-cream);
        }
        .kb-campaign-item.is-active {
          background: rgba(19,198,54,.14);
          border-color: rgba(109,255,138,.62);
          box-shadow: inset 0 0 0 1px rgba(109,255,138,.08), 0 0 22px rgba(19,198,54,.08);
        }
        .kb-campaign-title {
          display: block;
          color: var(--kb-cream);
          font-size: 12px;
          font-weight: 680;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .kb-campaign-brand {
          display: block;
          margin-top: 4px;
          color: var(--kb-faint);
          font-size: 11px;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .kb-campaign-item.is-active .kb-campaign-title,
        .kb-campaign-item.is-active .kb-campaign-brand {
          color: var(--kb-signal);
        }
        .kb-campaign-badge {
          align-self: start;
          border-radius: 999px;
          border: 1px solid rgba(236,234,209,.12);
          background: rgba(0,0,33,.36);
          color: var(--kb-faint);
          padding: 4px 6px;
          font-size: 9px;
          line-height: 1;
          text-transform: uppercase;
          max-width: 78px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .kb-campaign-item.is-active .kb-campaign-badge {
          color: var(--kb-signal);
          border-color: rgba(109,255,138,.42);
        }
        .kb-detail-panel {
          border: 1px solid var(--kb-line);
          border-radius: 14px;
          background: rgba(16,17,14,.32);
          padding: 18px;
          margin-top: 14px;
        }
        .kb-detail-title {
          margin: 0;
          font-size: clamp(24px, 3vw, 42px);
          line-height: 1;
          font-weight: 680;
          letter-spacing: 0;
        }
        .kb-detail-meta {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 10px;
          margin-top: 18px;
        }
        .kb-detail-meta div {
          border: 1px solid rgba(236,234,209,.10);
          border-radius: 10px;
          background: rgba(0,0,33,.32);
          padding: 10px;
        }
        .kb-detail-meta dt { color: var(--kb-faint); font-size: 10px; text-transform: uppercase; }
        .kb-detail-meta dd { margin: 5px 0 0; color: var(--kb-cream); font-size: 12px; font-weight: 650; line-height: 1.3; }
        .kb-card-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 14px;
        }
        .kb-card {
          border-radius: 12px;
          padding: 15px;
          min-height: 178px;
          cursor: pointer;
          color: var(--kb-cream);
          box-shadow: 0 16px 42px rgba(0,0,0,.26);
          transition: transform 180ms ease-out, border-color 180ms ease-out, background 180ms ease-out;
        }
        .kb-card:hover { transform: translateY(-3px); border-color: rgba(109,255,138,.42); background: rgba(16,17,14,.62); }
        .kb-card.is-active {
          border-color: rgba(109,255,138,.72);
          background: rgba(7,84,52,.42);
        }
        .kb-card-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 10px;
          margin-bottom: 14px;
        }
        .kb-award {
          border-radius: 999px;
          padding: 6px 8px;
          font-size: 10px;
          line-height: 1;
          text-transform: uppercase;
          color: var(--kb-muted);
          border: 1px solid rgba(236,234,209,.12);
          background: rgba(0,0,33,.38);
        }
        .kb-award-grand { color: var(--kb-signal); border-color: rgba(109,255,138,.38); }
        .kb-award-gold { color: #ECEAD1; border-color: rgba(236,234,209,.35); }
        .kb-award-silver { color: rgba(236,234,209,.78); }
        .kb-award-bronze { color: #d9b28d; }
        .kb-heart {
          width: 34px;
          height: 34px;
          border-radius: 999px;
          display: grid;
          place-items: center;
          border: 1px solid rgba(236,234,209,.14);
          background: rgba(0,0,33,.42);
          color: var(--kb-muted);
          flex: 0 0 auto;
        }
        .kb-heart.is-saved { color: var(--kb-signal); border-color: rgba(109,255,138,.42); background: rgba(19,198,54,.16); }
        .kb-card h3 {
          margin: 0;
          font-size: 17px;
          line-height: 1.12;
          font-weight: 650;
          letter-spacing: 0;
        }
        .kb-card p { margin: 8px 0 0; color: var(--kb-muted); font-size: 13px; line-height: 1.4; }
        .kb-card-meta {
          margin-top: 14px;
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          color: var(--kb-faint);
          font-size: 11px;
        }
        .kb-context-card {
          border-radius: 16px;
          border: 1px solid var(--kb-line);
          background: rgba(16,17,14,.32);
          padding: 14px;
        }
        .kb-context-card h2 { margin: 0; font-size: 20px; line-height: 1.08; font-weight: 650; }
        .kb-context-card dl { display: grid; grid-template-columns: 1fr; gap: 11px; margin: 16px 0; }
        .kb-context-card dt { color: var(--kb-faint); font-size: 10px; text-transform: uppercase; }
        .kb-context-card dd { margin: 4px 0 0; color: var(--kb-cream); font-size: 13px; font-weight: 600; }
        .kb-action-row { display: flex; gap: 8px; flex-wrap: wrap; }
        .kb-primary-link {
          min-height: 40px;
          border-radius: 10px;
          padding: 10px 13px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: var(--kb-green);
          color: #000021;
          font-weight: 700;
          font-size: 12px;
        }
        .kb-empty {
          border: 1px solid var(--kb-line);
          border-radius: 16px;
          padding: 36px;
          background: rgba(0,0,33,.62);
          color: var(--kb-muted);
          text-align: center;
        }
        .kb-chat {
          display: grid;
          gap: 10px;
          margin-top: 14px;
        }
        .kb-chat-log {
          display: grid;
          gap: 8px;
          max-height: 230px;
          overflow: auto;
          padding-right: 2px;
        }
        .kb-message {
          border: 1px solid rgba(236,234,209,.10);
          border-radius: 10px;
          padding: 10px;
          background: rgba(0,0,33,.46);
          backdrop-filter: blur(16px) saturate(1.1);
          color: var(--kb-muted);
          font-size: 12px;
          line-height: 1.45;
          white-space: pre-wrap;
        }
        .kb-message.is-user {
          margin-left: 28px;
          color: var(--kb-cream);
          border-color: rgba(109,255,138,.28);
          background: rgba(19,198,54,.10);
        }
        .kb-suggestion-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 7px;
        }
        .kb-chat-form {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 38px;
          gap: 8px;
        }
        .kb-chat-input {
          width: 100%;
          border: 1px solid var(--kb-line);
          border-radius: 10px;
          background: rgba(16,17,14,.42);
          color: var(--kb-cream);
          padding: 10px 12px;
          outline: none;
          font-size: 13px;
        }
        .kb-chat-input:focus { border-color: rgba(109,255,138,.55); box-shadow: 0 0 0 3px rgba(109,255,138,.08); }
        .kb-fullscreen .kb-topbar, .kb-fullscreen .kb-hero, .kb-fullscreen .kb-left-sidebar, .kb-fullscreen .kb-agent-panel, .kb-fullscreen .kb-card-grid, .kb-fullscreen .kb-results-head { display: none; }
        .kb-fullscreen .kb-workspace { display: block; }
        .kb-fullscreen .kb-page-layer { padding: 0; }
        .kb-fullscreen .kb-video-stage { position: fixed; inset: 0; display: grid; place-items: center; margin: 0; pointer-events: auto; background: #000021; }
        .kb-fullscreen .kb-video-shell { width: 96vw; max-width: 1480px; }
        @media (max-width: 1180px) {
          .kb-workspace { grid-template-columns: 230px minmax(0, 1fr); }
          .kb-agent-panel { grid-column: 1 / -1; position: relative; top: auto; max-height: none; }
          .kb-agent-panel .kb-context-card { display: grid; grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr); gap: 14px; align-items: start; }
          .kb-detail-meta { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        @media (max-width: 900px) {
          .kb-workspace { grid-template-columns: 1fr; }
          .kb-left-sidebar, .kb-agent-panel, .kb-video-stage { position: relative; top: auto; max-height: none; }
          .kb-left-sidebar { overflow: visible; }
          .kb-filter-panel { max-height: none; }
          .kb-campaign-list { max-height: 56vh; }
          .kb-left-sidebar { order: -2; }
          .kb-center-column { order: -1; }
          .kb-agent-panel .kb-context-card { display: block; }
        }
        @media (max-width: 640px) {
          .kb-page-layer { padding: 10px 10px 40px; }
          .kb-topbar { border-radius: 12px; }
          .kb-logo { height: 24px; }
          .kb-video-shell { width: 96vw; border-radius: 10px; }
          .kb-hero { padding-top: 28px; }
          .kb-title { font-size: 33px; }
          .kb-filter { max-width: 100%; }
          .kb-card-grid { grid-template-columns: 1fr; }
          .kb-detail-meta { grid-template-columns: 1fr; }
          .kb-suggestion-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="kb-page-layer">
        <header className="kb-topbar">
          <div className="flex items-center gap-4 min-w-0">
            <img src="/etoro-logo.svg" alt="eToro" className="kb-logo" />
            <div className="min-w-0">
              <div className="kb-kicker">Cannes Lions 2026</div>
              <div className="text-sm text-[rgba(236,234,209,.72)] truncate">Cannes Lions 2026</div>
            </div>
          </div>
          <div className="hidden lg:flex items-center gap-2">
            <span className="kb-chip"><span className="kb-dot"></span>{winnersList.length} winners</span>
            <span className="kb-chip">{videoMappingCount} video mappings</span>
            <span className="kb-chip">{savedCount} saved</span>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={toggleFullscreen}
              className={`kb-icon-btn ${isFullscreen ? 'is-active' : ''}`}
              title="Toggle fullscreen"
            >
              {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
            </button>
            <a className="kb-icon-btn" href="https://lovetheworkmore.com/2026-2/" target="_blank" rel="noopener noreferrer" title="Open source page">
              <ExternalLink className="h-4 w-4" />
              <span className="hidden sm:inline">Source</span>
            </a>
          </div>
        </header>

        <section className="kb-hero">
          <div className="kb-chip mb-5"><span className="kb-dot"></span>Cannes Lions 2026</div>
          <h1 className="kb-title">Cannes Lions 2026</h1>
          <p className="kb-subcopy">
            Cannes Lions 2026
          </p>
        </section>

        <main className="kb-workspace" aria-label="Cannes intelligence workspace">
          <aside className="kb-left-sidebar" aria-label="Cannes filters">
            <div className="kb-filter-panel">
              <div className="kb-panel-head">
                <h2 className="kb-panel-title">Archive controls</h2>
                <span className="kb-count">{filteredWinners.length}/{winnersList.length}</span>
              </div>
              <div className="kb-filter-group">
                <div className="kb-search-wrap">
                  <Search className="kb-search-icon" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentIndex(0); }}
                    placeholder="Search name or brand"
                    className="kb-search"
                  />
                </div>
              </div>
              <div className="kb-filter-group">
                <h3 className="kb-panel-title mb-3">Award Level</h3>
                <div className="kb-filter-stack">
                  {[
                    ['ALL', 'All winners', awardCounts.ALL || 0],
                    ['GRAND PRIX / TITANIUM', 'Grand Prix', awardCounts['GRAND PRIX / TITANIUM'] || 0],
                    ['GOLD', 'Gold', awardCounts.GOLD || 0],
                    ['SILVER', 'Silver', awardCounts.SILVER || 0],
                    ['BRONZE', 'Bronze', awardCounts.BRONZE || 0]
                  ].map(([value, label, count]) => (
                    <button
                      key={value}
                      onClick={() => { setSelectedCategory(value); setCurrentIndex(0); }}
                      className={`kb-filter ${selectedCategory === value ? 'is-active' : ''}`}
                    >
                      <span>{label}</span>
                      <span className="kb-count">{count}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div className="kb-filter-group">
                <h3 className="kb-panel-title mb-3">Lions Category</h3>
                <div className="kb-filter-stack">
                  <button
                    onClick={() => { setSelectedLionCategory('ALL'); setCurrentIndex(0); }}
                    className={`kb-filter ${selectedLionCategory === 'ALL' ? 'is-active' : ''}`}
                  >
                    <span>All Lions</span>
                    <span className="kb-count">{lionCategoryCounts.ALL || 0}</span>
                  </button>
                  {LION_CATEGORY_FILTERS.map(lionCategory => (
                    <button
                      key={lionCategory}
                      onClick={() => { setSelectedLionCategory(lionCategory); setCurrentIndex(0); }}
                      className={`kb-filter ${selectedLionCategory === lionCategory ? 'is-active' : ''}`}
                    >
                      <span>{lionCategory}</span>
                      <span className="kb-count">{lionCategoryCounts[lionCategory] || 0}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div className="kb-filter-group">
                <button
                  onClick={() => { setShowSavedOnly(prev => !prev); setCurrentIndex(0); }}
                  className={`kb-filter ${showSavedOnly ? 'is-active' : ''}`}
                  aria-pressed={showSavedOnly}
                >
                  <span className="inline-flex items-center gap-2">
                    <Heart className={`h-4 w-4 ${showSavedOnly || savedCount ? 'fill-current' : ''}`} />
                    {showSavedOnly ? 'Saved only' : 'Saved'}
                  </span>
                  <span className="kb-count">{savedCount}</span>
                </button>
                <div className="kb-export-actions" aria-label="Saved case export actions">
                  <button
                    type="button"
                    className="kb-export-btn"
                    onClick={handleDownloadSavedCsv}
                    disabled={savedExportRows.length === 0}
                    title="Download saved cases as CSV"
                  >
                    <FileText className="h-3.5 w-3.5" />
                    CSV
                  </button>
                  <button
                    type="button"
                    className="kb-export-btn"
                    onClick={handleCopySavedExport}
                    disabled={savedExportRows.length === 0}
                    title="Copy saved cases as a text table"
                  >
                    <Share2 className="h-3.5 w-3.5" />
                    Copy
                  </button>
                </div>
                {exportCopyStatus && (
                  <div className="kb-export-status" role="status">{exportCopyStatus}</div>
                )}
              </div>
            </div>
            <div className="kb-campaign-list-wrap">
              <div className="kb-panel-head">
                <h2 className="kb-panel-title">Campaigns</h2>
                <span className="kb-count">{selectedPosition || 0}/{filteredWinners.length}</span>
              </div>
              <div className="kb-campaign-list" aria-label="Filtered campaign list">
                {filteredWinners.length === 0 ? (
                  <div className="kb-empty">
                    <h2 className="text-base font-semibold mb-2">No campaigns match.</h2>
                    <button
                      className="kb-primary-link mx-auto mt-4"
                      onClick={() => { setSearchQuery(''); setSelectedCategory('ALL'); setSelectedLionCategory('ALL'); setShowSavedOnly(false); setCurrentIndex(0); }}
                    >
                      Reset filters
                    </button>
                  </div>
                ) : (
                  filteredWinners.map((winner, index) => {
                    const isActive = activeWinner && activeWinner.id === winner.id;
                    const isFavorite = favorites.includes(winner.id);
                    return (
                      <button
                        key={winner.id}
                        onClick={() => setCurrentIndex(index)}
                        className={`kb-campaign-item ${isActive ? 'is-active' : ''}`}
                      >
                        <span className="min-w-0">
                          <span className="kb-campaign-title">{winner.title}</span>
                          <span className="kb-campaign-brand">{winner.brand}</span>
                        </span>
                        <span className="flex items-center gap-1">
                          {isFavorite && <Heart className="h-3 w-3 fill-current text-[var(--kb-signal)]" />}
                          <span className="kb-campaign-badge">{winner.subcategory || winner.category.split('/')[0].trim()}</span>
                        </span>
                      </button>
                    );
                  })
                )}
              </div>
            </div>
          </aside>

          <section className="kb-center-column" aria-label="Campaign browser">
            <section className="kb-video-stage" aria-label="Sticky campaign video player">
              <div className="kb-video-shell">
                {activeWinner && activeVideoInfo.type === 'external' ? (
                  <div key={activeWinner.id} className="kb-external-video">
                    <div>
                      <div className="kb-chip mb-4">
                        <span className="kb-dot"></span>
                        External case link
                      </div>
                      <h2 className="text-2xl font-semibold mb-2">{activeWinner.title}</h2>
                      <p className="text-sm opacity-70 mb-5">{activeWinner.brand}</p>
                      <a className="kb-primary-link" href={activeSourceUrl} target="_blank" rel="noopener noreferrer">
                        View on {activeSourceName}
                        <ExternalLink className="h-4 w-4" />
                      </a>
                    </div>
                  </div>
                ) : activeWinner && activeEmbedUrl ? (
                  <iframe
                    key={`${activeWinner.id}-${activeEmbedUrl}`}
                    title={`Cannes Case Study: ${activeWinner.title}`}
                    src={activeEmbedUrl}
                    className="kb-video-frame"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                ) : (
                  <div className="kb-external-video">
                    <div>
                      <h2 className="text-2xl font-semibold mb-2">No campaign selected</h2>
                      <p className="text-sm opacity-70">Choose a winner from the cards below.</p>
                    </div>
                  </div>
                )}
              </div>
            </section>

            <div className="kb-results-head">
              <div>
                <div className="kb-kicker">Selected campaign</div>
                <div>{selectedPosition || 0} selected from {filteredWinners.length} visible winners</div>
              </div>
              <div className="hidden md:flex gap-2">
                <button className="kb-icon-btn" onClick={handlePrev} disabled={filteredWinners.length <= 1} title="Previous campaign">
                  <ChevronLeft className="h-4 w-4" />
                </button>
                <button className="kb-icon-btn" onClick={handleNext} disabled={filteredWinners.length <= 1} title="Next campaign">
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
            </div>

            {activeWinner ? (
              <section className="kb-detail-panel" aria-label="Selected campaign details">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <span className={`kb-award ${getAwardTone(activeWinner.category)}`}>
                      {activeWinner.subcategory || activeWinner.category.split('/')[0].trim()}
                    </span>
                    <h2 className="kb-detail-title mt-4">{activeWinner.title}</h2>
                    <p className="kb-subcopy !mt-3">{activeWinner.originalString}</p>
                  </div>
                  <button
                    className={`kb-heart ${favorites.includes(activeWinner.id) ? 'is-saved' : ''}`}
                    onClick={() => handleFavoriteToggle(activeWinner.id)}
                    title={favorites.includes(activeWinner.id) ? 'Remove from saved' : 'Save campaign'}
                  >
                    <Heart className={`h-4 w-4 ${favorites.includes(activeWinner.id) ? 'fill-current' : ''}`} />
                  </button>
                </div>
                <dl className="kb-detail-meta">
                  <div>
                    <dt>Brand</dt>
                    <dd>{activeWinner.brand}</dd>
                  </div>
                  <div>
                    <dt>Agency</dt>
                    <dd>{activeWinner.agency}</dd>
                  </div>
                  <div>
                    <dt>Award</dt>
                    <dd>{activeWinner.category}</dd>
                  </div>
                  <div>
                    <dt>Category</dt>
                    <dd>{activeWinner.lionCategory || 'General'}</dd>
                  </div>
                </dl>
                <div className="kb-action-row mt-4">
                  <button className="kb-icon-btn" onClick={handleCopyCode}>
                    <Share2 className="h-4 w-4" />
                    Copy
                  </button>
                  <a className="kb-primary-link" href={activeSourceUrl} target="_blank" rel="noopener noreferrer">
                    {activeVideoInfo.type === 'external' ? `View on ${activeSourceName}` : 'Open video'}
                    <ExternalLink className="h-4 w-4" />
                  </a>
                </div>
              </section>
            ) : (
              <div className="kb-empty">
                <h2 className="text-xl font-semibold mb-2">No campaigns match the current filters.</h2>
                <button
                  className="kb-primary-link mx-auto mt-4"
                  onClick={() => { setSearchQuery(''); setSelectedCategory('ALL'); setSelectedLionCategory('ALL'); setShowSavedOnly(false); setCurrentIndex(0); }}
                >
                  Reset filters
                </button>
              </div>
            )}
          </section>

          <aside className="kb-agent-panel" aria-label="AI campaign agent">
            <div className="kb-panel-head">
              <h2 className="kb-panel-title">AI Agent</h2>
              <Sparkles className="h-4 w-4 text-[var(--kb-signal)]" />
            </div>
            <div className="kb-context-card">
              <div>
                {activeWinner ? (
                  <>
                    <div className="kb-chip mb-4"><span className="kb-dot"></span>Ask about this campaign</div>
                    <h2>{activeWinner.title}</h2>
                    <p className="kb-subcopy !text-sm !mt-3">{activeWinner.brand}</p>
                    <dl>
                      <div>
                        <dt>Award</dt>
                        <dd>{activeWinner.category}</dd>
                      </div>
                      <div>
                        <dt>Lions category</dt>
                        <dd>{activeWinner.lionCategory || 'General'}</dd>
                      </div>
                      <div>
                        <dt>Agency</dt>
                        <dd>{activeWinner.agency}</dd>
                      </div>
                      <div>
                        <dt>Video</dt>
                        <dd>{activeVideoInfo.type === 'external' ? `External, ${activeSourceName}` : activeVideoInfo.type}</dd>
                      </div>
                    </dl>
                    <div className="kb-action-row">
                      <button className="kb-icon-btn" onClick={handlePrev} disabled={filteredWinners.length <= 1}>
                        <ChevronLeft className="h-4 w-4" />
                        Previous
                      </button>
                      <button className="kb-icon-btn" onClick={handleNext} disabled={filteredWinners.length <= 1}>
                        Next
                        <ChevronRight className="h-4 w-4" />
                      </button>
                      <button
                        className={`kb-icon-btn ${autoplay ? 'is-active' : ''}`}
                        onClick={() => setAutoplay(!autoplay)}
                      >
                        {autoplay ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
                        {autoplay ? 'Autoplay on' : 'Autoplay'}
                      </button>
                      <button
                        className={`kb-icon-btn ${favorites.includes(activeWinner.id) ? 'is-active' : ''}`}
                        onClick={() => handleFavoriteToggle(activeWinner.id)}
                      >
                        <Heart className={`h-4 w-4 ${favorites.includes(activeWinner.id) ? 'fill-current' : ''}`} />
                        {favorites.includes(activeWinner.id) ? 'Saved' : 'Save'}
                      </button>
                      <button className="kb-icon-btn" onClick={handleCopyCode}>
                        <Share2 className="h-4 w-4" />
                        Copy
                      </button>
                      <a className="kb-primary-link" href={activeSourceUrl} target="_blank" rel="noopener noreferrer">
                        {activeVideoInfo.type === 'external' ? `View on ${activeSourceName}` : 'Open video'}
                        <ExternalLink className="h-4 w-4" />
                      </a>
                    </div>
                  </>
                ) : (
                  <p>No active campaign.</p>
                )}
              </div>

              <div className="kb-chat">
                <div className="kb-suggestion-grid">
                  {QUICK_PROMPTS.map(prompt => (
                    <button
                      key={prompt}
                      className="kb-filter"
                      onClick={() => handleSendChatMessage(prompt)}
                      disabled={isAiLoading}
                    >
                      <span>{prompt}</span>
                      <HelpCircle className="h-4 w-4" />
                    </button>
                  ))}
                </div>
                <div className="kb-chat-log" aria-live="polite">
                  {chatMessages.slice(-4).map((message, index) => (
                    <div key={`${message.sender}-${index}`} className={`kb-message ${message.sender === 'user' ? 'is-user' : ''}`}>
                      {message.text}
                    </div>
                  ))}
                  {isAiLoading && (
                    <div className="kb-message">
                      <RefreshCw className="h-4 w-4 animate-spin inline mr-2" />
                      Thinking through the case.
                    </div>
                  )}
                  {aiError && <div className="kb-message">{aiError}</div>}
                </div>
                <form
                  className="kb-chat-form"
                  onSubmit={(event) => { event.preventDefault(); handleSendChatMessage(); }}
                >
                  <input
                    value={inputMessage}
                    onChange={(event) => setInputMessage(event.target.value)}
                    className="kb-chat-input"
                    placeholder="Ask about this campaign"
                  />
                  <button className="kb-icon-btn" type="submit" title="Send prompt" disabled={!inputMessage.trim() || isAiLoading}>
                    <Send className="h-4 w-4" />
                  </button>
                </form>
                <p className="text-xs leading-relaxed text-[rgba(236,234,209,.52)]">
                  Favorites sync with the local Cannes API when available and stay backed up in this browser.
                </p>
              </div>
            </div>
          </aside>
        </main>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-amber-500 selection:text-black">
      
      {/* Premium Header - Hidden completely in virtual fullscreen mode */}
      {(!isVirtualFullscreen) && (
        <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur-md px-6 py-4 flex items-center justify-between sticky top-0 z-30 transition-all">
          <div className="flex items-center space-x-3">
            <img src="/etoro-logo.svg" alt="eToro" className="h-7 w-auto opacity-90" />
            <div className="bg-gradient-to-br from-amber-400 via-orange-500 to-amber-600 p-2 rounded-lg shadow-lg shadow-amber-500/20">
              <Award className="h-6 w-6 text-slate-950 stroke-[2.5]" />
            </div>
            <div>
              <h1 className="text-xl font-black tracking-wider bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-100 bg-clip-text text-transparent uppercase">
                Cannes Lions 2026
              </h1>
              <p className="text-xs text-slate-400 font-mono">
                Cannes Lions 2026
              </p>
            </div>
          </div>

          {/* Stats Grid for Topbar */}
          <div className="hidden lg:flex items-center space-x-6 text-xs font-mono">
            <div className="text-right border-r border-slate-800 pr-4">
              <div className="text-slate-500">TOTAL WINNERS</div>
              <div className="text-amber-400 font-bold">{winnersList.length} Campaign entries</div>
            </div>
            <div className="text-right border-r border-slate-800 pr-4">
              <div className="text-slate-500">GRAND PRIX</div>
              <div className="text-yellow-300 font-bold font-mono">36</div>
            </div>
            <div className="text-right border-r border-slate-800 pr-4">
              <div className="text-slate-500">GOLD LIONS</div>
              <div className="text-yellow-100 font-bold font-mono font-medium">61</div>
            </div>
            <div className="text-right">
              <div className="text-slate-500 font-bold text-amber-500 flex items-center space-x-1">
                <Sparkles className="h-3 w-3 animate-pulse" />
                <span>GEMINI EXPERT CO-PILOT ACTIVE</span>
              </div>
            </div>
          </div>

          {/* Action controls */}
          <div className="flex items-center space-x-3">
            {/* Native HTML5 + Virtual sandbox hybrid Fullscreen control */}
            <button 
              onClick={toggleFullscreen}
              className={`p-2 rounded-lg transition-colors ${isFullscreen ? 'bg-amber-500 text-slate-950' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}
              title="Toggle Native Browser / Simulated Fullscreen (F)"
            >
              {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
            </button>
            
            <button 
              onClick={() => setTheaterMode(!theaterMode)}
              className={`p-2 rounded-lg transition-colors ${theaterMode ? 'bg-amber-500 text-slate-950' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}
              title="Toggle Theater Mode (T)"
            >
              <Tv className="h-4 w-4" />
            </button>
            <a 
              href="https://lovetheworkmore.com/2026-2/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-1 text-xs bg-slate-800 hover:bg-slate-700 border border-slate-700 hover:border-slate-600 px-3 py-2 rounded-lg text-slate-300 transition-all font-mono"
            >
              <span>Source page</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </header>
      )}

      {/* Main Workspace Frame */}
      <div className="flex-1 flex overflow-hidden relative">

        {/* SIDEBAR: Winner Index (hidden in Theater Mode or Virtual Fullscreen) */}
        {(!theaterMode && !isVirtualFullscreen) && (
          <aside className="w-80 border-r border-slate-900 bg-slate-900/40 backdrop-blur-sm flex flex-col z-10 shrink-0">
            {/* Filter Area */}
            <div className="p-4 border-b border-slate-900 space-y-3">
              <div className="relative">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-500" />
                <input 
                  type="text" 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search brands, agencies..." 
                  className="w-full bg-slate-950 border border-slate-800 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 pl-9 pr-4 py-2 rounded-lg text-sm text-slate-200 outline-none placeholder-slate-500 transition-colors"
                />
              </div>

              {/* Award level selector */}
              <div className="grid grid-cols-2 gap-1.5 text-xs font-mono">
                <button 
                  onClick={() => { setSelectedCategory('ALL'); setCurrentIndex(0); }}
                  className={`py-1.5 px-2 rounded text-left transition-all flex items-center justify-between ${selectedCategory === 'ALL' ? 'bg-slate-800 text-slate-100 font-bold border-l-2 border-amber-500' : 'text-slate-400 hover:bg-slate-900'}`}
                >
                  <span>All Winners</span>
                  <span className="text-[10px] opacity-60">({awardCounts.ALL || 0})</span>
                </button>
                <button 
                  onClick={() => { setSelectedCategory('GRAND PRIX / TITANIUM'); setCurrentIndex(0); }}
                  className={`py-1.5 px-2 rounded text-left transition-all flex items-center justify-between ${selectedCategory === 'GRAND PRIX / TITANIUM' ? 'bg-amber-950/40 text-amber-300 font-bold border-l-2 border-amber-500' : 'text-slate-400 hover:bg-slate-900'}`}
                >
                  <span className="truncate">Grand Prix</span>
                  <span className="text-[10px] opacity-60">({awardCounts['GRAND PRIX / TITANIUM'] || 0})</span>
                </button>
                <button 
                  onClick={() => { setSelectedCategory('GOLD'); setCurrentIndex(0); }}
                  className={`py-1.5 px-2 rounded text-left transition-all flex items-center justify-between ${selectedCategory === 'GOLD' ? 'bg-yellow-950/40 text-yellow-300 font-bold border-l-2 border-yellow-500' : 'text-slate-400 hover:bg-slate-900'}`}
                >
                  <span>Gold</span>
                  <span className="text-[10px] opacity-60">({awardCounts.GOLD || 0})</span>
                </button>
                <button 
                  onClick={() => { setSelectedCategory('SILVER'); setCurrentIndex(0); }}
                  className={`py-1.5 px-2 rounded text-left transition-all flex items-center justify-between ${selectedCategory === 'SILVER' ? 'bg-slate-800/80 text-slate-200 font-bold border-l-2 border-slate-400' : 'text-slate-400 hover:bg-slate-900'}`}
                >
                  <span>Silver</span>
                  <span className="text-[10px] opacity-60">({awardCounts.SILVER || 0})</span>
                </button>
                <button 
                  onClick={() => { setSelectedCategory('BRONZE'); setCurrentIndex(0); }}
                  className={`py-1.5 px-2 rounded text-left transition-all flex items-center justify-between col-span-2 ${selectedCategory === 'BRONZE' ? 'bg-amber-900/10 text-orange-300 font-bold border-l-2 border-orange-500' : 'text-slate-400 hover:bg-slate-900'}`}
                >
                  <span>Bronze Lions</span>
                  <span className="text-[10px] opacity-60">({awardCounts.BRONZE || 0})</span>
                </button>
              </div>

              {/* Lions category selector */}
              <div className="space-y-1.5">
                <div className="flex items-center gap-1.5 text-[10px] text-slate-500 font-mono uppercase tracking-wider">
                  <Sliders className="h-3 w-3" />
                  <span>Lions Category</span>
                </div>
                <div className="max-h-28 overflow-y-auto flex flex-wrap gap-1.5 pr-1">
                  <button
                    onClick={() => { setSelectedLionCategory('ALL'); setCurrentIndex(0); }}
                    className={`px-2 py-1 rounded-full text-[10px] font-mono transition-all border ${selectedLionCategory === 'ALL' ? 'bg-amber-500/15 text-amber-300 border-amber-500/40' : 'bg-slate-950 text-slate-400 border-slate-800 hover:border-slate-700 hover:text-slate-200'}`}
                  >
                    All Lions <span className="opacity-60">({lionCategoryCounts.ALL || 0})</span>
                  </button>
                  {LION_CATEGORY_FILTERS.map(lionCategory => (
                    <button
                      key={lionCategory}
                      onClick={() => { setSelectedLionCategory(lionCategory); setCurrentIndex(0); }}
                      className={`px-2 py-1 rounded-full text-[10px] font-mono transition-all border ${selectedLionCategory === lionCategory ? 'bg-amber-500/15 text-amber-300 border-amber-500/40' : 'bg-slate-950 text-slate-400 border-slate-800 hover:border-slate-700 hover:text-slate-200'}`}
                    >
                      {lionCategory} <span className="opacity-60">({lionCategoryCounts[lionCategory] || 0})</span>
                    </button>
                  ))}
                </div>
              </div>

              <button
                onClick={() => { setShowSavedOnly(prev => !prev); setCurrentIndex(0); }}
                className={`w-full py-2 px-3 rounded-lg text-xs font-mono transition-all flex items-center justify-center gap-2 border ${showSavedOnly ? 'bg-amber-500 text-slate-950 border-amber-400 font-bold' : 'bg-slate-950 text-slate-300 border-slate-800 hover:border-amber-500/40 hover:text-amber-300'}`}
              >
                <Heart className={`h-3.5 w-3.5 ${showSavedOnly ? 'fill-slate-950' : favorites.length ? 'fill-amber-500 text-amber-500' : ''}`} />
                <span>{showSavedOnly ? `Showing Saved (${favorites.length})` : `Saved (${favorites.length})`}</span>
              </button>
            </div>

            {/* List entries */}
            <div className="flex-1 overflow-y-auto divide-y divide-slate-950">
              {filteredWinners.length === 0 ? (
                <div className="p-8 text-center text-slate-500 text-sm font-mono">
                  No campaigns match your filters
                </div>
              ) : (
                filteredWinners.map((winner, index) => {
                  const isActive = activeWinner && activeWinner.id === winner.id;
                  const isFavorite = favorites.includes(winner.id);
                  let badgeBg = "bg-slate-800 text-slate-400";
                  if (winner.category.includes('GRAND PRIX')) badgeBg = "bg-gradient-to-r from-amber-600 to-yellow-600 text-slate-950 font-bold";
                  else if (winner.category === 'GOLD') badgeBg = "bg-yellow-500/20 text-yellow-300";
                  else if (winner.category === 'SILVER') badgeBg = "bg-slate-700/55 text-slate-200";
                  else if (winner.category === 'BRONZE') badgeBg = "bg-orange-500/10 text-orange-300";

                  return (
                    <div 
                      key={winner.id}
                      onClick={() => setCurrentIndex(index)}
                      className={`p-3 text-left cursor-pointer transition-all flex items-start justify-between space-x-2 group ${isActive ? 'bg-slate-900 border-l-4 border-amber-500' : 'hover:bg-slate-900/60'}`}
                    >
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-1.5 mb-1 flex-wrap gap-y-1">
                          <span className={`text-[9px] px-1.5 py-0.5 rounded uppercase font-mono tracking-wider ${badgeBg}`}>
                            {winner.subcategory || winner.category.split('/')[0].trim()}
                          </span>
                          {isFavorite && <Heart className="h-2.5 w-2.5 text-amber-500 fill-amber-500" />}
                        </div>
                        <h4 className={`text-xs font-bold truncate ${isActive ? 'text-amber-400' : 'text-slate-200 group-hover:text-amber-400'}`}>
                          {winner.title}
                        </h4>
                        <p className="text-[10px] text-slate-400 truncate mt-0.5">
                          {winner.brand}
                        </p>
                        <p className="text-[9px] text-slate-500 font-mono truncate">
                          {winner.agency}
                        </p>
                      </div>
                      <span className="text-[10px] text-slate-600 font-mono self-center">
                        #{(index + 1).toString().padStart(2, '0')}
                      </span>
                    </div>
                  );
                })
              )}
            </div>

            {/* Quick Filter Info footer */}
            <div className="p-3 bg-slate-950 border-t border-slate-900 text-[10px] text-slate-500 font-mono text-center">
              Viewing {filteredWinners.length} / {winnersList.length} Winners
            </div>
          </aside>
        )}

        {/* CENTER STAGE: Slide Deck */}
        <main className={`flex-1 flex flex-col bg-slate-950 relative overflow-y-auto transition-all ${isVirtualFullscreen ? 'fixed inset-0 z-50 w-full h-full' : ''}`}>
          
          {/* Virtual Fullscreen Escape Action Banner */}
          {isVirtualFullscreen && (
            <div className="bg-amber-500 text-slate-950 py-2 px-6 flex justify-between items-center text-xs font-mono font-bold animate-fadeIn">
              <div className="flex items-center space-x-2">
                <span className="h-2 w-2 rounded-full bg-slate-950 animate-ping"></span>
                <span>SIMULATED FULLSCREEN MODE (Permissions fallback bypass active)</span>
              </div>
              <button 
                onClick={toggleFullscreen}
                className="bg-slate-950 text-amber-400 px-3 py-1 rounded hover:bg-slate-900 hover:text-white transition-all flex items-center space-x-1"
              >
                <Minimize2 className="h-3.5 w-3.5" />
                <span>EXIT FULLSCREEN (ESC)</span>
              </button>
            </div>
          )}

          {activeWinner ? (
            <div className="flex-1 p-6 md:p-8 lg:p-12 flex flex-col max-w-5xl mx-auto w-full justify-center">
              
              {/* Slide Meta Card */}
              <div className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="px-2.5 py-1 text-xs font-mono tracking-widest font-black uppercase rounded bg-gradient-to-r from-amber-500 to-yellow-600 text-slate-950 shadow-md shadow-amber-500/10">
                      {activeWinner.category}
                    </span>
                    {activeWinner.subcategory && (
                      <span className="text-xs text-amber-400 font-mono border border-amber-500/20 px-2 py-0.5 rounded bg-amber-500/5">
                        {activeWinner.subcategory}
                      </span>
                    )}
                  </div>
                  
                  {/* Title Area - "Place the name of the link as the title" */}
                  <h2 className="text-2xl md:text-3.5xl font-black tracking-tight leading-tight uppercase text-white drop-shadow-sm">
                    {activeWinner.title}
                  </h2>
                  <p className="text-sm text-slate-300 mt-1 font-medium">
                    Brand: <span className="text-amber-400 font-bold">{activeWinner.brand}</span>
                  </p>
                </div>

                {/* Micro Actions */}
                <div className="flex items-center space-x-2 shrink-0">
                  <button 
                    onClick={() => handleFavoriteToggle(activeWinner.id)}
                    className="p-2 rounded-lg bg-slate-900 border border-slate-800 hover:border-slate-700 text-slate-300 transition-colors"
                    title={favorites.includes(activeWinner.id) ? "Remove from Favorites" : "Add to Favorites"}
                  >
                    <Heart className={`h-4 w-4 ${favorites.includes(activeWinner.id) ? 'text-amber-500 fill-amber-500' : ''}`} />
                  </button>
                  <button 
                    onClick={handleCopyCode}
                    className="p-2 rounded-lg bg-slate-900 border border-slate-800 hover:border-slate-700 text-slate-300 transition-colors"
                    title="Copy Campaign info"
                  >
                    <Share2 className="h-4 w-4" />
                  </button>
                  <a 
                    href={getSearchUrl(activeWinner)}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="p-2 rounded-lg bg-slate-900 border border-slate-800 hover:border-amber-500/40 text-slate-300 hover:text-amber-400 transition-all flex items-center space-x-1 text-xs"
                    title="Open Campaign Video Source"
                  >
                    <ExternalLink className="h-4 w-4" />
                    <span className="hidden md:inline font-mono">Video Link</span>
                  </a>
                </div>
              </div>

              {/* MAIN CONTENT AREA: Youtube Case Study Video Player in the center */}
              <div className="relative aspect-video w-full rounded-2xl overflow-hidden shadow-2xl border border-slate-800/80 bg-slate-950 group">
                <iframe
                  title={`Cannes Case Study: ${activeWinner.title}`}
                  src={getEmbedUrl(activeWinner)}
                  className="absolute inset-0 w-full h-full border-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>

                {/* Subtitle / Tip overlay */}
                <div className="absolute top-3 left-3 bg-slate-900/90 backdrop-blur-md px-3 py-1.5 rounded-lg border border-slate-800 text-[11px] font-mono opacity-0 group-hover:opacity-100 transition-opacity flex items-center space-x-2 pointer-events-none">
                  <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse"></span>
                  <span className="text-slate-300">ケーススタディビデオ / YouTube Embed Mode</span>
                </div>
              </div>

              {/* Slide Meta Footer Details */}
              <div className="mt-4 p-4 bg-slate-900/30 rounded-xl border border-slate-900/60 flex flex-wrap gap-y-4 items-center justify-between text-xs text-slate-400">
                <div className="flex items-center space-x-6">
                  <div>
                    <span className="text-slate-500 block uppercase font-mono text-[9px] tracking-wider">Agency / Network</span>
                    <span className="text-slate-200 font-bold">{activeWinner.agency}</span>
                  </div>
                  <div>
                    <span className="text-slate-500 block uppercase font-mono text-[9px] tracking-wider">Cannes Category</span>
                    <span className="text-amber-400 font-bold flex items-center space-x-1">
                      <Award className="h-3.5 w-3.5" />
                      <span>{activeWinner.category}</span>
                    </span>
                  </div>
                </div>

                <div className="flex items-center space-x-2 font-mono text-[10px]">
                  <span>Viewing slide</span>
                  <span className="text-slate-200 font-bold bg-slate-900 px-2 py-1 rounded">{currentIndex + 1}</span>
                  <span>of</span>
                  <span className="text-slate-200 font-bold bg-slate-900 px-2 py-1 rounded">{filteredWinners.length}</span>
                </div>
              </div>

              {/* Slider Deck Navigation & Autoplay Controls */}
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 py-4 border-t border-slate-900">
                
                {/* Navigation arrows */}
                <div className="flex items-center space-x-3 w-full sm:w-auto justify-between sm:justify-start">
                  <button 
                    onClick={handlePrev}
                    disabled={filteredWinners.length <= 1}
                    className="p-3 rounded-xl bg-slate-900 hover:bg-slate-850 text-slate-300 hover:text-amber-400 transition-all border border-slate-800 disabled:opacity-40 disabled:cursor-not-allowed flex items-center space-x-1"
                    title="Previous Slide (Left Arrow)"
                  >
                    <ChevronLeft className="h-5 w-5" />
                    <span className="text-xs font-mono hidden md:inline">PREV</span>
                  </button>

                  <button 
                    onClick={handleNext}
                    disabled={filteredWinners.length <= 1}
                    className="p-3 rounded-xl bg-slate-900 hover:bg-slate-850 text-slate-300 hover:text-amber-400 transition-all border border-slate-800 disabled:opacity-40 disabled:cursor-not-allowed flex items-center space-x-1"
                    title="Next Slide (Right Arrow)"
                  >
                    <span className="text-xs font-mono hidden md:inline">NEXT</span>
                    <ChevronRight className="h-5 w-5" />
                  </button>
                </div>

                {/* Slideshow Player Options */}
                <div className="flex items-center space-x-4 bg-slate-900/40 p-2 rounded-xl border border-slate-900 w-full sm:w-auto justify-center">
                  <button 
                    onClick={() => setAutoplay(!autoplay)}
                    className={`flex items-center space-x-1 px-3 py-1.5 rounded-lg text-xs font-mono transition-all ${autoplay ? 'bg-amber-500 text-slate-950 font-bold animate-pulse' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}
                    title="Toggle Autoplay Presentation (Space)"
                  >
                    {autoplay ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
                    <span>{autoplay ? 'AUTOPLAY ACTIVE' : 'AUTOPLAY DECK'}</span>
                  </button>

                  <div className="flex items-center space-x-1">
                    <span className="text-[10px] text-slate-500 font-mono">TIMER:</span>
                    <select 
                      value={autoplayInterval} 
                      onChange={(e) => setAutoplayInterval(Number(e.target.value))}
                      className="bg-slate-950 border border-slate-800 rounded px-1.5 py-0.5 text-xs text-slate-300 font-mono focus:outline-none focus:border-amber-500"
                    >
                      <option value="5">5s</option>
                      <option value="10">10s</option>
                      <option value="15">15s</option>
                      <option value="20">20s</option>
                      <option value="30">30s</option>
                    </select>
                  </div>
                </div>

              </div>

            </div>
          ) : (
            <div className="flex-1 flex flex-col items-center justify-center p-12 text-center text-slate-400">
              <Award className="h-16 w-16 text-slate-700 mb-4 animate-pulse" />
              <h3 className="text-lg font-bold text-slate-200">No Winners Loaded</h3>
              <p className="text-sm text-slate-500 max-w-md mt-1">
                Try modifying your search filter, choosing a different award or Lions category, or resetting.
              </p>
              <button 
                onClick={() => { setSearchQuery(''); setSelectedCategory('ALL'); setSelectedLionCategory('ALL'); setShowSavedOnly(false); }}
                className="mt-4 px-4 py-2 rounded bg-slate-900 border border-slate-800 hover:bg-slate-800 text-xs font-mono text-amber-400 transition-all"
              >
                Clear Search & Filters
              </button>
            </div>
          )}

          {/* Quick instructions indicator overlay */}
          <div className="p-3 bg-slate-950 text-center text-[10px] text-slate-600 font-mono border-t border-slate-900/60">
            PRO-TIP: Use <kbd className="bg-slate-900 px-1 rounded text-slate-400">←</kbd> and <kbd className="bg-slate-900 px-1 rounded text-slate-400">→</kbd> arrow keys to slide through the Cannes winners. Spacebar toggles Autoplay. Press <kbd className="bg-slate-900 px-1 rounded text-slate-400">F</kbd> for Fullscreen.
          </div>
        </main>

        {/* RIGHT SIDEBAR: AI Companion & Strategy Analyst (hidden in Theater Mode or Virtual Fullscreen) */}
        {(!theaterMode && !isVirtualFullscreen) && (
          <aside className="w-80 border-l border-slate-900 bg-slate-900/40 backdrop-blur-sm flex flex-col z-10 shrink-0">
            
            {/* Strategy header */}
            <div className="p-4 border-b border-slate-900 flex items-center justify-between bg-slate-900/10">
              <div className="flex items-center space-x-2">
                <Sparkles className="h-4 w-4 text-amber-400 animate-pulse" />
                <h3 className="text-sm font-black tracking-wide text-slate-200 uppercase font-mono">
                  AI Campaign Analyst
                </h3>
              </div>
              <span className="text-[9px] bg-amber-500/10 text-amber-400 px-1.5 py-0.5 rounded font-mono border border-amber-500/20">
                GEMINI 2.5
              </span>
            </div>

            {/* Campaign Summary Widget */}
            {activeWinner && (
              <div className="p-4 border-b border-slate-900 bg-slate-900/20">
                <span className="text-[9px] uppercase tracking-wider text-slate-500 font-mono block mb-1">
                  Active Dossier
                </span>
                <div className="text-xs font-bold text-slate-300 uppercase truncate">
                  {activeWinner.title}
                </div>
                <div className="text-[11px] text-slate-400 mt-0.5 font-mono">
                  {activeWinner.brand} • {activeWinner.agency}
                </div>

                {/* Instant Strategy Query presets */}
                <div className="mt-3 grid grid-cols-2 gap-1.5">
                  <button
                    onClick={() => handleSendChatMessage("What is the main creative hook of this campaign?")}
                    className="text-[10px] text-left p-1.5 rounded bg-slate-900 hover:bg-slate-850 text-slate-300 border border-slate-800 hover:border-amber-500/35 transition-all truncate"
                  >
                    💡 Creative Hook
                  </button>
                  <button
                    onClick={() => handleSendChatMessage("Describe the target audience, cultural insight, and business impact.")}
                    className="text-[10px] text-left p-1.5 rounded bg-slate-900 hover:bg-slate-850 text-slate-300 border border-slate-800 hover:border-amber-500/35 transition-all truncate"
                  >
                    🎯 Strategy & Insight
                  </button>
                  <button
                    onClick={() => handleSendChatMessage("What lessons can other marketers learn from this winner?")}
                    className="text-[10px] text-left p-1.5 rounded bg-slate-900 hover:bg-slate-850 text-slate-300 border border-slate-800 hover:border-amber-500/35 transition-all truncate col-span-2"
                  >
                    🏆 Cannes Jury Takeaways
                  </button>
                </div>
              </div>
            )}

            {/* Chat message space */}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 flex flex-col text-xs">
              {chatMessages.map((msg, i) => (
                <div 
                  key={i} 
                  className={`p-2.5 rounded-lg max-w-[90%] leading-relaxed ${
                    msg.sender === 'user' 
                      ? 'bg-amber-500 text-slate-950 font-medium self-end rounded-br-none' 
                      : 'bg-slate-900 text-slate-300 border border-slate-800 self-start rounded-bl-none'
                  }`}
                >
                  <div className="font-bold text-[9px] uppercase tracking-wider opacity-60 mb-1 font-mono">
                    {msg.sender === 'user' ? 'Advertiser Request' : 'Jury President Gemini'}
                  </div>
                  <div className="whitespace-pre-line prose prose-invert prose-xs">
                    {msg.text}
                  </div>
                </div>
              ))}

              {isAiLoading && (
                <div className="bg-slate-900/60 border border-slate-850 p-3 rounded-lg self-start flex items-center space-x-2 text-slate-400">
                  <RefreshCw className="h-3 w-3 animate-spin text-amber-500" />
                  <span className="font-mono text-[10px]">Analyzing the 2026 Cannes database...</span>
                </div>
              )}

              {aiError && (
                <div className="p-2.5 rounded bg-red-950/40 text-red-300 border border-red-900/35 text-[11px] font-mono leading-normal">
                  ⚠️ {aiError}
                </div>
              )}
            </div>

            {/* Message input bar */}
            <div className="p-3 border-t border-slate-900 bg-slate-950/80">
              <form 
                onSubmit={(e) => { e.preventDefault(); handleSendChatMessage(); }}
                className="flex items-center space-x-2"
              >
                <input 
                  type="text" 
                  value={inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  placeholder="Ask for creative insights..."
                  className="flex-1 bg-slate-900 border border-slate-800 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 text-xs text-slate-100 placeholder-slate-500 outline-none rounded-lg py-2 px-3"
                />
                <button 
                  type="submit"
                  disabled={!inputMessage.trim() || isAiLoading}
                  className="p-2 bg-amber-500 hover:bg-amber-400 text-slate-950 rounded-lg transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <Send className="h-3.5 w-3.5" />
                </button>
              </form>
            </div>

          </aside>
        )}

      </div>

    </div>
  );
}
